// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:55:40.137Z
// Property: Pembrooke Apartment Homes (ID: 6767906449166899)
// Collections: 23 amenities, 4 floorplans (live), 49 photos, 41 POIs, 2 reviews, 5 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166899",
  "property_external_id": "495819",
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Pembrooke+Apartments/data=!4m2!3m1!1s0x0:0x1af45ef503908570?sa=X&ved=2ahUKEwjIj4eXkbySAxXEkmoFHSkgEQUQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495819 p0505487",
  "property_status": null,
  "property_slug": "pembrooke-apartment-homes",
  "property_name": "Pembrooke Apartment Homes",
  "property_website_url": "https://www.apartmentskentwashington.com/",
  "property_domain": "https://www.apartmentskentwashington.com/",
  "property_address": "25907 27th Place South",
  "property_full_address": "25907 27th Pl S, Kent, WA 98032",
  "property_address_1": "25907 27th Place South",
  "property_address_2": null,
  "property_address_city": "Kent",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98032",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": null,
  "property_address_latitude": "47.369054",
  "property_address_longitude": "-122.2976127",
  "property_email": "Pembrooke@ctlmanagement.com",
  "property_phone": "(844) 807-4456",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Pembrooke Apartments in Kent, WA, where comfort meets convenience. Choose from stylish one and two-bedroom floor plans, each featuring modern amenities like updated finishes, private patios, and a cozy wood-burning fireplace. Enjoy a refreshing dip in our seasonal pool, or unwind with friends at the clubhouse. Your ideal home awaits!",
  "property_long_description": "Welcome to Pembrooke Apartments, your perfect retreat in Kent, WA! Discover an inviting community that balances comfort and style with our selection of spacious one and two-bedroom floor plans tailored to fit your lifestyle. Each apartment is designed for modern living, featuring updated units with elegant satin nickel finishes in 70% of our homes, complete with cozy wood-burning fireplaces, convenient washer and dryer sets, and private patios or decks for relaxing evenings.\n\nExperience a wealth of amenities right outside your door! Stay active in our state-of-the-art fitness center, take a refreshing dip in the outdoor seasonal pool, or enjoy leisurely strolls along our jogging trail surrounded by scenic views. For pet lovers, our off-leash dog park is the perfect place for your furry friends to roam freely.\n\nAt Pembrooke Apartments, we prioritize your convenience with 24-hour package lockers, smoke-free housing, and flexible lease terms. Connect with neighbors at our vibrant resident lounge, complete with a coffee bar, or host friends in our clubhouse equipped for rentals. We also provide a range of online services, including rent payments and maintenance requests, making managing your home a breeze.\n\nWith BBQ areas and a resident activity program, you’ll find plenty of opportunities to socialize and unwind. Plus, carports and attached storage options add that extra layer of convenience.\n\nDon’t miss the chance to make Pembrooke Apartments your new home! Browse our availability today or schedule a tour to experience our community firsthand. Your perfect living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d2c2e-fdec-706f-97e1-51c18078cc59.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of the property with a stone chimney and colorful flowerbeds.",
    "public_id": "019d2c2e-fdec-706f-97e1-51c18078cc59",
    "storage_key": "property/6767906449166899/019d2c2e-fdec-706f-97e1-51c18078cc59.webp",
    "width": 1766,
    "height": 825
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400-varies",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30 | Deposit $400",
  "property_online_leasing_url": "https://apartmentskentwashington.securecafe.com/onlineleasing/pembrooke-apartment-homes/guestlogin",
  "property_resident_portal_url": "https://apartmentskentwashington.securecafenet.com/residentservices/pembrooke-apartment-homes/userlogin",
  "property_apply_now_url": "https://apartmentskentwashington.securecafe.com/onlineleasing/pembrooke-apartment-homes/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d73de-8fcb-77cf-b440-4587ed138f8e.webp",
  "property_primary_logo_media": {
    "alt_text": "Pembroke Apartments logo",
    "public_id": "019d73de-8fcb-77cf-b440-4587ed138f8e",
    "storage_key": "property/6767906449166899/019d73de-8fcb-77cf-b440-4587ed138f8e.webp",
    "width": 550,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d73de-8f33-764f-a3a8-1a69ebb8c5db.webp",
  "property_secondary_logo_media": {
    "alt_text": "Pembrooke Apartments logo",
    "public_id": "019d73de-8f33-764f-a3a8-1a69ebb8c5db",
    "storage_key": "property/6767906449166899/019d73de-8f33-764f-a3a8-1a69ebb8c5db.webp",
    "width": 552,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019de0b2-7c6c-7028-9cd3-63364b6e6793.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Graphic with black and white bars",
    "public_id": "019de0b2-7c6c-7028-9cd3-63364b6e6793",
    "storage_key": "property/6767906449166899/019de0b2-7c6c-7028-9cd3-63364b6e6793.webp",
    "width": 550,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019de0b2-6fff-71d9-a403-50e90cebc16b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangle image.",
    "public_id": "019de0b2-6fff-71d9-a403-50e90cebc16b",
    "storage_key": "property/6767906449166899/019de0b2-6fff-71d9-a403-50e90cebc16b.webp",
    "width": 550,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "636 - 840",
  "property_sqft_min": "636",
  "property_sqft_max": "840",
  "property_price_range": "1495 - 2050",
  "property_price_min": "1495",
  "property_price_max": "2050",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/PembrookeApartmentHomes/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ6zISwS5akFQRcIWQA_Ve9Bo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/pembrooke-apartments-kent",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pembrooke Apartments",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Pembrooke Apartments in Kent, WA, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans, complete with modern amenities like a state-of-the-art fitness center, seasonal outdoor pool, and private patios. Enjoy scenic views, pet-friendly spaces, and a vibrant resident community—all at your fingertips!",
  "property_home_floorplans_blurb": "Welcome to Pembrooke Apartments in the heart of Kent, WA, where modern living meets comfort. Our thoughtfully designed floor plans cater to every lifestyle, ensuring you find the space that feels just right. Browse our available apartment homes and envision your new life at Pembrooke today!",
  "property_home_gallery_blurb": "At Pembrooke Apartments in Kent, WA, your lifestyle finds its perfect match with spacious one and two-bedroom floor plans. Enjoy modern amenities like a fitness center, seasonal outdoor pool, and scenic views, all from the comfort of a smoke-free community. Picture yourself relaxing by the BBQ area or unwinding in your private patio!",
  "property_home_neighborhood_blurb": "Welcome to Pembrooke Apartments in Kent, WA, where your new home is surrounded by a vibrant community. Enjoy easy access to the tranquil Saltwater State Park, the engaging MaST Center Aquarium, and the beautiful Riverbend Golf Complex. Experience convenience and excitement just minutes from your doorstep!",
  "property_home_reviews_blurb": "At Pembrooke Apartments in Kent, WA, residents rave about the welcoming atmosphere, stating, “The staff truly makes you feel at home!” Experience the charm and comfort of our community. See what our residents have to say about living at Pembrooke Apartments—your perfect home awaits!",
  "property_neighborhood_blurb": "Nestled in vibrant Kent, WA, Pembrooke Apartments offers the perfect blend of comfort and convenience. Enjoy quick access to cultural gems like the Pacific Bonsai Museum, Highline College, and the MaST Center Aquarium. Stay active at nearby parks, gyms, and the accesso ShoWare Center. Uncover your ideal neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Pembrooke Apartments in Kent, WA, every detail elevates your living experience. Enjoy spacious one and two-bedroom layouts with modern finishes, plus a vibrant community featuring a fitness center, seasonal pool, and scenic jogging trails. Embrace a lifestyle that’s both active and relaxing—your new home awaits!",
  "property_applynow_blurb": "At Pembrooke Apartments in Kent, WA, your ideal living space awaits with stylish one- and two-bedroom floor plans. Enjoy top-notch amenities like a fitness center, seasonal outdoor pool, and serene walking trails. Ready to elevate your lifestyle? Lease your new home online today and experience unparalleled comfort and convenience!",
  "property_contactus_blurb": "At Pembrooke Apartments in Kent, WA, find your perfect space with our thoughtfully designed one and two-bedroom floor plans. Whether you seek cozy solitude or room for sharing, Pembrooke promises comfort and style tailored to your lifestyle. Have questions? Our leasing team is ready to assist you today!",
  "property_faqs_blurb": "At Pembrooke Apartments in Kent, WA, we offer a variety of thoughtfully designed floor plans, including one and two-bedroom options. Our vibrant community creates the perfect backdrop for your next chapter. Delve into our FAQs page to uncover all your burning questions and learn what makes Pembrooke truly special.",
  "property_floorplans_blurb": "At Pembrooke Apartments in Kent, WA, our thoughtfully designed one and two-bedroom floor plans offer a perfect blend of comfort and style. Whether you seek spacious living or cozy retreats, you'll find an ideal match. Browse our available apartment homes today to uncover your perfect sanctuary.",
  "property_gallery_blurb": "At Pembrooke Apartments in Kent, WA, vibrant living meets modern comfort. Whether you prefer a cozy one-bedroom or a spacious two-bedroom, our updated homes feature satin nickel finishes and inviting wood-burning fireplaces. Enjoy scenic views, a lively clubhouse, and a refreshing outdoor pool. Picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Pembrooke Apartments in scenic Kent, WA, where modern living meets comfort. Choose from stylish one- or two-bedroom floor plans, complete with private patios, updated finishes, and cozy wood-burning fireplaces. Enjoy top-notch amenities like a fitness center, an outdoor pool, and a dog park—all at your fingertips! Check out our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Pembrooke Apartments in Kent, WA, your four-legged friends are cherished members of the family. With a welcoming environment for indoor cats and small dogs—each weighing up to 25 lbs—our community ensures a joyful space for both you and your pets, complemented by flexible pet policies.",
  "property_referafriend_blurb": "At Pembrooke Apartments in Kent, WA, every floor plan—from cozy one-bedrooms to spacious two-bedrooms—invites you to create your perfect home. Share the experience with friends, and enhance your community living. Great friends make great neighbors—refer a friend to Pembrooke today and elevate your lifestyle together!",
  "property_residentaccess_blurb": "At Pembrooke Apartments in Kent, WA, our stylish one and two-bedroom floor plans offer the perfect blend of comfort and convenience. Elevate your living experience by accessing the resident portal—pay rent, schedule maintenance, and manage your home effortlessly. Your ideal lifestyle awaits just a click away!",
  "property_reviews_blurb": "At Pembrooke Apartments in Kent, WA, residents rave about the vibrant community atmosphere, highlighting, \"The staff is friendly and responsive, making it feel like home.\" Dive into our reviews and see what our residents have to say about their enriching experiences in our welcoming neighborhood and modern living spaces!",
  "property_created_at": "1762784992572",
  "property_scheduletour_blurb": "At Pembrooke Apartments in Kent, WA, your ideal home awaits—choose from spacious one and two-bedroom floor plans designed for comfort and style. Join our vibrant community, where residents enjoy more than a place to live. Schedule a tour today and hear firsthand why Pembrooke is the perfect fit for you!",
  "property_thankyou_blurb": "Thank you for reaching out to Pembrooke Apartments in Kent, WA! Our stunning one and two-bedroom floor plans are designed for comfort and style. A member of our team will connect with you shortly to help you find your perfect home at Pembrooke, where modern living meets welcoming community charm.",
  "property_virtualtours_blurb": "Welcome to Pembrooke Apartments in Kent, WA, where modern living meets comfort. With thoughtfully designed one and two-bedroom floor plans, our community is tailored for your lifestyle. Immerse yourself in a virtual tour today and envision your new home in a place that truly feels like yours!",
  "property_copyright": "2025 All Rights Reserved. Pembrooke Apartments",
  "property_seo_title_home": "Pembrooke Apartments |  Apartments in Kent, WA",
  "property_seo_description_home": "Experience comfort at Pembrooke Apartments in Kent, WA. Enjoy updated living spaces, a fitness center, dog park, and scenic views. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Kent, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Pembrooke Apartments in Kent, WA. Choose from spacious one and two-bedroom floor plans designed for comfort and style. Browse now!",
  "property_seo_title_amenities": "Amenities | Kent, WA Apartments for Rent",
  "property_seo_description_amenities": "Discover Pembrooke Apartments in Kent, WA! Enjoy modern living with a fitness center, pool, and scenic views. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Kent, WA",
  "property_seo_description_gallery": "Picture life at Pembrooke Apartments! Modern 1 & 2-bedroom homes in Kent, WA, featuring a pool, dog park, and more. Your vibrant community awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Pembrooke Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Pembrooke Apartments in Kent, WA! Take a virtual tour of our stylish one and two-bedroom homes—your future oasis awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Pembrooke Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Pembrooke Apartments in Kent, WA! Use our interactive map to explore stunning floor plans and fantastic amenities tailored for you.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Kent, WA",
  "property_seo_description_neighborhood": "Uncover the charm of Kent, WA at Pembrooke Apartments. Dive into local favorites, parks, and dining just steps from your new home. Your neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Pembrooke Apartments",
  "property_seo_description_contact": "Connect with Pembrooke Apartments in Kent, WA! Inquire about our one and two-bedroom floor plans. Your new home awaits. Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Kent, WA",
  "property_seo_description_faqs": "Your perfect home awaits at Pembrooke Apartments in Kent. From scenic views to a fitness center, find answers to all your FAQs about our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kent, WA",
  "property_seo_description_reviews": "Discover Pembrooke Apartments in Kent, WA! Check our resident reviews and see why our community offers top amenities and stunning views.",
  "property_seo_title_applynow": "Apply Now | Apartments in Kent, WA",
  "property_seo_description_applynow": "Discover modern living at Pembrooke Apartments in Kent, WA. Select your ideal floor plan and enjoy premium amenities—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Pembrooke Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Pembrooke Apartments in Kent, WA! Access your portal to pay rent, request maintenance, and manage your resident experience effortlessly.",
  "property_seo_title_referafriend": "Refer A Friend | Pembrooke Apartments",
  "property_seo_description_referafriend": "Refer a friend to Pembrooke Apartments in Kent, WA, and enjoy the perks of great company! Great friends make fabulous neighbors. Join our community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Pembrooke Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Pembrooke Apartments in Kent, WA. Schedule a tour today and envision your future in a vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Pembrooke Apartments",
  "property_seo_description_privacy": "At Pembrooke Apartments in Kent, WA, your privacy is our priority. Read our policy to see how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Pembrooke Apartments",
  "property_seo_description_accessibility": "Pembrooke Apartments in Kent, WA, prioritizes digital inclusion, ensuring an accessible online experience for all.",
  "property_seo_title_sitemap": "Sitemap | Pembrooke Apartments",
  "property_seo_description_sitemap": "Navigate your way to comfort and convenience at Pembrooke Apartments in Kent, WA. Check out our sitemap to find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Pembrooke Apartments",
  "property_seo_description_thankyou": "Thanks for reaching out to Pembrooke Apartments in Kent! Our team will connect with you soon to help you find your perfect home. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Kent, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778875035769",
  "amenities": [
    {
      "id": "ec_5afe27b4a4eb925a53432153",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429188",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-78bd-73fe-93a9-18d498bea931.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills and exercise equipment in the community gym.",
        "public_id": "019d4972-78bd-73fe-93a9-18d498bea931",
        "storage_key": "property/6767906449166899/019d4972-78bd-73fe-93a9-18d498bea931.webp",
        "width": 1766,
        "height": 1179
      },
      "amenity_image_alt_text": "Fitness Studio at Pembrooke Apartment Homes, Kent, WA,State Of Art Fitness Center at Pembrooke Apartment Homes, Kent, WA 98032",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_622e0246e5989d5ea84ba26f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429191",
      "title": "Outdoor Seasonal Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_723535ed9ac5f15b95c25963",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429185",
      "title": "BBQ Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-96ca-7566-aa94-e672fa26b4ba.webp",
      "amenity_image_media": {
        "alt_text": "Playground and picnic area with barbecue grill at apartment complex.",
        "public_id": "019d4972-96ca-7566-aa94-e672fa26b4ba",
        "storage_key": "property/6767906449166899/019d4972-96ca-7566-aa94-e672fa26b4ba.webp",
        "width": 1766,
        "height": 1179
      },
      "amenity_image_alt_text": "Picnic Area at Pembrooke Apartment Homes, Kent Washington",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32ed391bcd6ce77f4cbd83fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429192",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-9232-73ff-89bc-f84b5d829f43.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
        "public_id": "019d4972-9232-73ff-89bc-f84b5d829f43",
        "storage_key": "property/6767906449166899/019d4972-9232-73ff-89bc-f84b5d829f43.webp",
        "width": 1766,
        "height": 1179
      },
      "amenity_image_alt_text": "Play Structure at Pembrooke Apartment Homes, Kent, 98032",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a0992d9e3300d1c54eb16ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429186",
      "title": "Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96b19617dd9b96bcdfa1d983",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80665086",
      "title": "Wi-Fi And Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1363854b176c28331572462a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "86462673",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_952f16e44ee5fe34e7d9d006",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "86462674",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3cfee9be6d900432b6358ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80665088",
      "title": "Off Leash Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-9e38-705a-9532-2011e32c2f04.webp",
      "amenity_image_media": {
        "alt_text": "Community dog park with agility equipment and playground in the background.",
        "public_id": "019d4972-9e38-705a-9532-2011e32c2f04",
        "storage_key": "property/6767906449166899/019d4972-9e38-705a-9532-2011e32c2f04.webp",
        "width": 1766,
        "height": 1179
      },
      "amenity_image_alt_text": "Bark Park View at Pembrooke Apartment Homes, Washington, 98032,Pet Park at Pembrooke Apartment Homes, Washington",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b0daa3c60586193e73feea9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429189",
      "title": "Jogging Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d95c7673f5f214ff2c81c01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "86462672",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-419f-700a-b67a-04db07c75eaf.webp",
      "amenity_image_media": {
        "alt_text": "Lounge area with kitchen bar and seating near a stone fireplace.",
        "public_id": "019d4972-419f-700a-b67a-04db07c75eaf",
        "storage_key": "property/6767906449166899/019d4972-419f-700a-b67a-04db07c75eaf.webp",
        "width": 2437,
        "height": 1641
      },
      "amenity_image_alt_text": "Clubhouse Kitchen Bar Seating Area at Pembrooke Apartment Homes, Kent,Clubhouse Fireplace Seating Area at Pembrooke Apartment Homes, Kent Washington",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a6a259b4628568a775a1161",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "86462675",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10cf5aa0a6d0e9360271f9a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "81384759",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a1cf0325bc66857dfe1e272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "82390194",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_120f5ce4ecccdd10dcadd17d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "82390196",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d391db8cf571c56d116ddd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "86462676",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4170b15811b01cfaab39648b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429196",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-b5fb-75a2-9a30-6c4687fb7a45.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with a white washer and dryer, decorated with framed art and a basket of clean towels.",
        "public_id": "019d08ad-b5fb-75a2-9a30-6c4687fb7a45",
        "storage_key": "property/6767906449166899/019d08ad-b5fb-75a2-9a30-6c4687fb7a45.webp",
        "width": 415,
        "height": 600
      },
      "amenity_image_alt_text": "Pembrooke Model Apartment Washer & Dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7958af77602256bb51c0e186",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429197",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a07c-76da-ab3c-9f4c0926e558.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace and entryway",
        "public_id": "019d1edc-a07c-76da-ab3c-9f4c0926e558",
        "storage_key": "property/6767906449166899/019d1edc-a07c-76da-ab3c-9f4c0926e558.webp",
        "width": 1016,
        "height": 641
      },
      "amenity_image_alt_text": "Vacant Apartment Living Room & Fireplace at Pembrooke Apartment Homes, Kent, WA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c17ff37fdf678a874b0111c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429193",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-ab43-77df-86b2-5035ff737bee.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and a balcony view.",
        "public_id": "019d08ad-ab43-77df-86b2-5035ff737bee",
        "storage_key": "property/6767906449166899/019d08ad-ab43-77df-86b2-5035ff737bee.webp",
        "width": 900,
        "height": 600
      },
      "amenity_image_alt_text": "Pembrooke Model Apartment Living Room & Patio Sliding Door",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b95eea690fde34cc56f4dd1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "87310439",
      "title": "Split Bedroom Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38bbae6cc7d9ab1b2a574b24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "87310441",
      "title": "Attached Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b9c160e8465f4f98ca2e130",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "80429190",
      "title": "Updated Units With Satin Nickel Finishes - In Most Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a084-71c9-86df-7b6eb0b1fd3c.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, sink, dishwasher, refrigerator, and a window overlooking greenery.",
        "public_id": "019d1edc-a084-71c9-86df-7b6eb0b1fd3c",
        "storage_key": "property/6767906449166899/019d1edc-a084-71c9-86df-7b6eb0b1fd3c.webp",
        "width": 974,
        "height": 657
      },
      "amenity_image_alt_text": "Upgraded Kitchen Side View at Pembrooke Apartment Homes, Kent, 98032",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f752af93e2788dc25a36debb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "yardi",
      "external_id": "87310440",
      "title": "Scenic Views - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_117b06db50dfbfc03100641f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0e-1bc2-707c-a3e2-22dc5360cb52.webp",
      "image_media": {
        "alt_text": "Pembroke Apartment Homes monument sign with stone pillars and landscaping.",
        "public_id": "019d1c0e-1bc2-707c-a3e2-22dc5360cb52",
        "storage_key": "property/6767906449166899/019d1c0e-1bc2-707c-a3e2-22dc5360cb52.webp",
        "width": 1600,
        "height": 1057
      },
      "title": "Community",
      "description": "Welcome to Pembroke Apartment Homes, featuring a prominent monument sign with stone pillars, elegant lettering, and vibrant floral landscaping.",
      "link": "false",
      "alt_text": "Pembroke Apartment Homes monument sign with stone pillars and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_MonumentSign.jpg"
    },
    {
      "id": "ec_824d06734116b0c62de67951",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-d6b3-728f-855b-747ef1f9a7db.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, white dishwasher, and white stove.",
        "public_id": "019d1c02-d6b3-728f-855b-747ef1f9a7db",
        "storage_key": "property/6767906449166899/019d1c02-d6b3-728f-855b-747ef1f9a7db.webp",
        "width": 1029,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this well-equipped kitchen featuring ample wooden cabinetry, durable granite countertops, a deep stainless steel sink, and modern appliances including a dishwasher and stove.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, white dishwasher, and white stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelKitchen.jpg"
    },
    {
      "id": "ec_70a515e3ee9943966f7723ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-9b33-764e-8b97-a3d1fb854b4c.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, adjacent to a kitchen with white cabinets and a window.",
        "public_id": "019d08ad-9b33-764e-8b97-a3d1fb854b4c",
        "storage_key": "property/6767906449166899/019d08ad-9b33-764e-8b97-a3d1fb854b4c.webp",
        "width": 900,
        "height": 600
      },
      "title": "Apartment",
      "description": "Beautifully appointed dining area adjacent to a well-equipped kitchen, perfect for enjoying meals at home.",
      "link": "false",
      "alt_text": "Dining area with a table and chairs, adjacent to a kitchen with white cabinets and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelDiningRoom01.jpg"
    },
    {
      "id": "ec_739cff6771227b7f5dbc4965",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-9b31-7730-b13d-9e26dbcfd50b.webp",
      "image_media": {
        "alt_text": "Dining room with a wooden table set for four, upholstered chairs, and a living room in the background.",
        "public_id": "019d08ad-9b31-7730-b13d-9e26dbcfd50b",
        "storage_key": "property/6767906449166899/019d08ad-9b31-7730-b13d-9e26dbcfd50b.webp",
        "width": 900,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy meals in our elegantly set dining room, perfect for entertaining guests or intimate dinners, adjacent to a comfortable living area.",
      "link": "false",
      "alt_text": "Dining room with a wooden table set for four, upholstered chairs, and a living room in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelDiningRoom02.jpg"
    },
    {
      "id": "ec_e863b2bfa1ebf05ba45c12b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-a7d2-72cc-a4e5-378c59034cab.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, dining area, and entryway.",
        "public_id": "019d08ad-a7d2-72cc-a4e5-378c59034cab",
        "storage_key": "property/6767906449166899/019d08ad-a7d2-72cc-a4e5-378c59034cab.webp",
        "width": 900,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, dining space, and convenient entryway. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a fireplace, dining area, and entryway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelLivingRoom01.jpg"
    },
    {
      "id": "ec_f72d88d80ecb92762a5d57d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-ab43-77df-86b2-5035ff737bee.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and a balcony view.",
        "public_id": "019d08ad-ab43-77df-86b2-5035ff737bee",
        "storage_key": "property/6767906449166899/019d08ad-ab43-77df-86b2-5035ff737bee.webp",
        "width": 900,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into a welcoming living space, featuring a comfortable sofa, a cozy armchair, and a stylish coffee table, all leading to a private balcony.",
      "link": "false",
      "alt_text": "Living room with a sofa, armchair, coffee table, and a balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelLivingRoom02.jpg"
    },
    {
      "id": "ec_1a55751d2ca7317e43b2c072",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-ab46-7419-af40-1303427f9dd6.webp",
      "image_media": {
        "alt_text": "Bedroom with large bed, desk, and mirrored closet doors reflecting another bed.",
        "public_id": "019d08ad-ab46-7419-af40-1303427f9dd6",
        "storage_key": "property/6767906449166899/019d08ad-ab46-7419-af40-1303427f9dd6.webp",
        "width": 900,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a desk area, and mirrored closet doors that create an illusion of more space.",
      "link": "false",
      "alt_text": "Bedroom with large bed, desk, and mirrored closet doors reflecting another bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelMasterBedroom.jpg"
    },
    {
      "id": "ec_4e631f08717ab272ccaaa366",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-b3c0-757c-8bf4-a78a1ce52198.webp",
      "image_media": {
        "alt_text": "Bedroom with a twin bed and a window overlooking the pool area.",
        "public_id": "019d08ad-b3c0-757c-8bf4-a78a1ce52198",
        "storage_key": "property/6767906449166899/019d08ad-b3c0-757c-8bf4-a78a1ce52198.webp",
        "width": 900,
        "height": 600
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring a comfortable twin bed with colorful bedding, and a large window offering a view of the property's pool and outdoor amenities.",
      "link": "false",
      "alt_text": "Bedroom with a twin bed and a window overlooking the pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_dbe3cd9672f93a7f87fdad6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ad-b5fb-75a2-9a30-6c4687fb7a45.webp",
      "image_media": {
        "alt_text": "Laundry room with a white washer and dryer, decorated with framed art and a basket of clean towels.",
        "public_id": "019d08ad-b5fb-75a2-9a30-6c4687fb7a45",
        "storage_key": "property/6767906449166899/019d08ad-b5fb-75a2-9a30-6c4687fb7a45.webp",
        "width": 415,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-home laundry room featuring a washer and dryer, perfect for keeping your clothes fresh.",
      "link": "false",
      "alt_text": "Laundry room with a white washer and dryer, decorated with framed art and a basket of clean towels.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ModelLaundry.jpg"
    },
    {
      "id": "ec_8e9a7f96c2d0c7789a7cb7ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-d644-7637-a2b6-f454353c5a8f.webp",
      "image_media": {
        "alt_text": "Black refrigerator and electric stove in a kitchen with dark wood cabinets.",
        "public_id": "019d1c02-d644-7637-a2b6-f454353c5a8f",
        "storage_key": "property/6767906449166899/019d1c02-d644-7637-a2b6-f454353c5a8f.webp",
        "width": 1801,
        "height": 1211
      },
      "title": "Apartment",
      "description": "Kitchen featuring a black refrigerator and electric stove, complemented by dark wood cabinetry and a light-colored countertop.",
      "link": "false",
      "alt_text": "Black refrigerator and electric stove in a kitchen with dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant1x1Kitchen.jpg"
    },
    {
      "id": "ec_2196c70dfadde327ab88755f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-d908-77ed-aaba-e9da78c258c6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink and appliances.",
        "public_id": "019d1c02-d908-77ed-aaba-e9da78c258c6",
        "storage_key": "property/6767906449166899/019d1c02-d908-77ed-aaba-e9da78c258c6.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, a spacious countertop, and modern appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink and appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant1x1KitchenLaundry.jpg"
    },
    {
      "id": "ec_b9f83efd0f047528b2050a7a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-dbc5-769e-9f96-8f2c03f97a40.webp",
      "image_media": {
        "alt_text": "Living room with a pass-through to the kitchen and a sliding glass door leading to a balcony.",
        "public_id": "019d1c02-dbc5-769e-9f96-8f2c03f97a40",
        "storage_key": "property/6767906449166899/019d1c02-dbc5-769e-9f96-8f2c03f97a40.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral carpeting and a view of the kitchen and balcony. Perfect for any decor.",
      "link": "false",
      "alt_text": "Living room with a pass-through to the kitchen and a sliding glass door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant1x1DiningRoom.jpg"
    },
    {
      "id": "ec_2f6a811c2fbe7304578157e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-ffa7-75b4-a129-4990640affab.webp",
      "image_media": {
        "alt_text": "Living room with carpet, beige walls, and a sliding glass door leading to a balcony.",
        "public_id": "019d1c0d-ffa7-75b4-a129-4990640affab",
        "storage_key": "property/6767906449166899/019d1c0d-ffa7-75b4-a129-4990640affab.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious living area featuring neutral carpet, a sliding glass door for balcony access, and ample wall space for personalization.",
      "link": "false",
      "alt_text": "Living room with carpet, beige walls, and a sliding glass door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant1x1LivingRoomSlider.jpg"
    },
    {
      "id": "ec_75a83d5ce61fcdcf04892eeb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-d70d-7598-bad9-b4ccfdd8dd31.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and a doorway leading to a bathroom.",
        "public_id": "019d1c02-d70d-7598-bad9-b4ccfdd8dd31",
        "storage_key": "property/6767906449166899/019d1c02-d70d-7598-bad9-b4ccfdd8dd31.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral carpeting and access to a bathroom, perfect for creating your personal sanctuary.",
      "link": "false",
      "alt_text": "Empty bedroom with carpet and a doorway leading to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant1x1Bedroom.jpg"
    },
    {
      "id": "ec_8701f3d03a4ee953b80bae9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-d584-72fc-9237-08de4bab55b0.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub with a shower.",
        "public_id": "019d1c02-d584-72fc-9237-08de4bab55b0",
        "storage_key": "property/6767906449166899/019d1c02-d584-72fc-9237-08de4bab55b0.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with sink, toilet, and a bathtub with a showerhead.",
      "link": "false",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub with a shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant1x1Bathroom.jpg"
    },
    {
      "id": "ec_9188971f87bbe204271e424f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-d711-70cd-b540-e301b8448f28.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, a black refrigerator, dishwasher, and stove.",
        "public_id": "019d1c02-d711-70cd-b540-e301b8448f28",
        "storage_key": "property/6767906449166899/019d1c02-d711-70cd-b540-e301b8448f28.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, granite-style countertops, a dishwasher, refrigerator, and stove. Ample counter space and a large window provide a bright and functional cooking area.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, a black refrigerator, dishwasher, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x1Kitchen.jpg"
    },
    {
      "id": "ec_4cc8fe9d3f33613df4ea5ee5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c02-da93-731a-9c3a-7c2666d01e53.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, and black electric stove.",
        "public_id": "019d1c02-da93-731a-9c3a-7c2666d01e53",
        "storage_key": "property/6767906449166899/019d1c02-da93-731a-9c3a-7c2666d01e53.webp",
        "width": 1766,
        "height": 1159
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment kitchen, featuring dark wood cabinetry, granite countertops, and a sleek black electric stove, perfect for preparing your favorite meals.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, and black electric stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x1KitchenBar.jpg"
    },
    {
      "id": "ec_6196dcf9c0508dd46b5f52fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-fa96-77ac-a007-45809aad3aad.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet adjacent to a bathroom vanity with sink and mirror.",
        "public_id": "019d1c0d-fa96-77ac-a007-45809aad3aad",
        "storage_key": "property/6767906449166899/019d1c0d-fa96-77ac-a007-45809aad3aad.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer located in a dedicated closet, offering convenience. Adjacent bathroom features a vanity with a sink and mirror.",
      "link": "false",
      "alt_text": "Washer and dryer in laundry closet adjacent to a bathroom vanity with sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x1BathroomLaundry.jpg"
    },
    {
      "id": "ec_c97f33b7af769f13d68bf9d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-fbb6-718f-ac72-ff9ca3f42f16.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel sink, and a window overlooking the property.",
        "public_id": "019d1c0d-fbb6-718f-ac72-ff9ca3f42f16",
        "storage_key": "property/6767906449166899/019d1c0d-fbb6-718f-ac72-ff9ca3f42f16.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring dark wood cabinetry, a deep stainless steel sink, and a large window providing ample natural light and a view of the property's exterior.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel sink, and a window overlooking the property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2Kitchen.jpg"
    },
    {
      "id": "ec_2de1470c9d2940cdf3220031",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-fc93-7422-a85d-5a01e2da4cbc.webp",
      "image_media": {
        "alt_text": "Kitchen sink and countertop with a window overlooking trees and buildings.",
        "public_id": "019d1c0d-fc93-7422-a85d-5a01e2da4cbc",
        "storage_key": "property/6767906449166899/019d1c0d-fc93-7422-a85d-5a01e2da4cbc.webp",
        "width": 1689,
        "height": 1144
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring a deep sink, ample counter space, and a window with a view of the surrounding greenery.",
      "link": "false",
      "alt_text": "Kitchen sink and countertop with a window overlooking trees and buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2KitchenSink.jpg"
    },
    {
      "id": "ec_a69e2712ac5bdacd38957bcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-fcee-7338-9756-127f6257b497.webp",
      "image_media": {
        "alt_text": "Living room with carpet, fireplace, and sliding glass doors leading to a balcony.",
        "public_id": "019d1c0d-fcee-7338-9756-127f6257b497",
        "storage_key": "property/6767906449166899/019d1c0d-fcee-7338-9756-127f6257b497.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy brick fireplace and sliding glass doors that open to a private balcony, perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Living room with carpet, fireplace, and sliding glass doors leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2LivingRoom.jpg"
    },
    {
      "id": "ec_fc45f6d950c9586cc52e1507",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-fdb3-772b-a420-32459135bf76.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and sliding glass door",
        "public_id": "019d1c0d-fdb3-772b-a420-32459135bf76",
        "storage_key": "property/6767906449166899/019d1c0d-fdb3-772b-a420-32459135bf76.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy brick fireplace and access to a private patio or balcony through sliding glass doors. The neutral carpet and clean white walls provide a versatile backdrop for any decor.",
      "link": "false",
      "alt_text": "Living room with a fireplace and sliding glass door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2LivingRoomSlider.jpg"
    },
    {
      "id": "ec_a3019d8c3addf05dfa29b522",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-faee-746f-b054-993841a8944e.webp",
      "image_media": {
        "alt_text": "Living room with a brick fireplace and view of the kitchen.",
        "public_id": "019d1c0d-faee-746f-b054-993841a8944e",
        "storage_key": "property/6767906449166899/019d1c0d-faee-746f-b054-993841a8944e.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a brick fireplace and an open view to the kitchen area. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with a brick fireplace and view of the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2LivingRoomFireplace.jpg"
    },
    {
      "id": "ec_34bca63810c27aa2870aa3a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-fe7d-759b-ab96-4dbd84a14f8b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a fireplace.",
        "public_id": "019d1c0d-fe7d-759b-ab96-4dbd84a14f8b",
        "storage_key": "property/6767906449166899/019d1c0d-fe7d-759b-ab96-4dbd84a14f8b.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and an adjacent kitchen, featuring a cozy brick fireplace for a warm ambiance.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2LivingRoomEntry.jpg"
    },
    {
      "id": "ec_812c299987f010e5337df9ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1c0d-fafd-727e-b623-4fe3ff9cd12a.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and doors to a bathroom and another room.",
        "public_id": "019d1c0d-fafd-727e-b623-4fe3ff9cd12a",
        "storage_key": "property/6767906449166899/019d1c0d-fafd-727e-b623-4fe3ff9cd12a.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet with mirrored doors, and access to a private bathroom and additional living space.",
      "link": "false",
      "alt_text": "Bedroom with a closet and doors to a bathroom and another room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2PrimaryBedroomBathroom.jpg"
    },
    {
      "id": "ec_3a5971db07792340428e758f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a19a-779d-abad-039b84db4d3f.webp",
      "image_media": {
        "alt_text": "A clean and functional bathroom with a single vanity, toilet, and bathtub with shower.",
        "public_id": "019d1edc-a19a-779d-abad-039b84db4d3f",
        "storage_key": "property/6767906449166899/019d1edc-a19a-779d-abad-039b84db4d3f.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Step into a well-maintained bathroom featuring a spacious vanity, a modern toilet, and a relaxing bathtub with a shower, perfect for your daily routine.",
      "link": "false",
      "alt_text": "A clean and functional bathroom with a single vanity, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2PrimaryBathroom.jpg"
    },
    {
      "id": "ec_e6369c5c8048883661361ec7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-4076-7789-9dd2-f4387cde6f76.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet.",
        "public_id": "019d4972-4076-7789-9dd2-f4387cde6f76",
        "storage_key": "property/6767906449166899/019d4972-4076-7789-9dd2-f4387cde6f76.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer conveniently located in a closet, making laundry day a breeze.",
      "link": "false",
      "alt_text": "Washer and dryer in a laundry closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2Laundry.jpg"
    },
    {
      "id": "ec_0107ca94391c8570e5ec28ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a131-73ed-b007-7e0727a1ad85.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet and window.",
        "public_id": "019d1edc-a131-73ed-b007-7e0727a1ad85",
        "storage_key": "property/6767906449166899/019d1edc-a131-73ed-b007-7e0727a1ad85.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a large mirrored closet and a bright window overlooking greenery. Freshly carpeted and ready for your personal touch.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2SecondBedroom.jpg"
    },
    {
      "id": "ec_76f65d76ca0cb384b3e100b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a0d2-714a-9e74-d74fba70460c.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, vanity, medicine cabinet, and laundry closet with washer and dryer.",
        "public_id": "019d1edc-a0d2-714a-9e74-d74fba70460c",
        "storage_key": "property/6767906449166899/019d1edc-a0d2-714a-9e74-d74fba70460c.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a vanity with ample counter space, a large medicine cabinet for storage, and a convenient laundry closet equipped with a washer and dryer.",
      "link": "false",
      "alt_text": "Bathroom with sink, vanity, medicine cabinet, and laundry closet with washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2SmallSecondBathroom.jpg"
    },
    {
      "id": "ec_8f30687a7def8479db8befbe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a082-776d-8c93-631adcbcc762.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a mirror.",
        "public_id": "019d1edc-a082-776d-8c93-631adcbcc762",
        "storage_key": "property/6767906449166899/019d1edc-a082-776d-8c93-631adcbcc762.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Apartment",
      "description": "Freshen up in this clean and modern bathroom, featuring a spacious bathtub, a convenient vanity with storage, and a large mirror for your convenience.",
      "link": "false",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_Vacant2x2LargeSecondBathroom.jpg"
    },
    {
      "id": "ec_00c2822feb052f05fdba4dbb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-3fb0-708e-9159-7630e1846a08.webp",
      "image_media": {
        "alt_text": "Kitchen with sink, refrigerator, and stove.",
        "public_id": "019d4972-3fb0-708e-9159-7630e1846a08",
        "storage_key": "property/6767906449166899/019d4972-3fb0-708e-9159-7630e1846a08.webp",
        "width": 1029,
        "height": 665
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white cabinetry, a stainless steel sink, and a refrigerator. Perfect for everyday cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with sink, refrigerator, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_UpgradedKitchen01.jpg"
    },
    {
      "id": "ec_9ca723d0f128601e94cbb941",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a084-71c9-86df-7b6eb0b1fd3c.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, sink, dishwasher, refrigerator, and a window overlooking greenery.",
        "public_id": "019d1edc-a084-71c9-86df-7b6eb0b1fd3c",
        "storage_key": "property/6767906449166899/019d1edc-a084-71c9-86df-7b6eb0b1fd3c.webp",
        "width": 974,
        "height": 657
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white cabinetry, a double-basin sink, a dishwasher, and a full-size refrigerator. The large window provides natural light and a view of the outdoors.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, sink, dishwasher, refrigerator, and a window overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_UpgradedKitchen02.jpg"
    },
    {
      "id": "ec_a025ef016a2fe99d156075f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a07c-76da-ab3c-9f4c0926e558.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and entryway",
        "public_id": "019d1edc-a07c-76da-ab3c-9f4c0926e558",
        "storage_key": "property/6767906449166899/019d1edc-a07c-76da-ab3c-9f4c0926e558.webp",
        "width": 1016,
        "height": 641
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace and an entryway leading outside. Enjoy a comfortable and inviting atmosphere in this apartment.",
      "link": "false",
      "alt_text": "Living room with fireplace and entryway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_VacantLivingRoom.jpg"
    },
    {
      "id": "ec_8305bc3d77408afc62cca734",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a068-73ee-abeb-9b933123bcf3.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with mirrored closet doors and view into hallway and bathroom.",
        "public_id": "019d1edc-a068-73ee-abeb-9b933123bcf3",
        "storage_key": "property/6767906449166899/019d1edc-a068-73ee-abeb-9b933123bcf3.webp",
        "width": 1028,
        "height": 682
      },
      "title": "Apartment",
      "description": "Relax in this expansive bedroom, complete with plush carpeting, a large mirrored closet, and easy access to the hallway and a well-appointed bathroom.",
      "link": "false",
      "alt_text": "Spacious bedroom with mirrored closet doors and view into hallway and bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_VacantBedroom.jpg"
    },
    {
      "id": "ec_471762e966316e1ac4d9056f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d1edc-a06a-705b-83e5-07d0dbb05242.webp",
      "image_media": {
        "alt_text": "Bathroom with a tub, toilet, and vanity with a sink and mirror.",
        "public_id": "019d1edc-a06a-705b-83e5-07d0dbb05242",
        "storage_key": "property/6767906449166899/019d1edc-a06a-705b-83e5-07d0dbb05242.webp",
        "width": 989,
        "height": 654
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, toilet, and a vanity with a sink and mirror, perfect for daily routines.",
      "link": "false",
      "alt_text": "Bathroom with a tub, toilet, and vanity with a sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_VacantUpgradedBathroom02.jpg"
    },
    {
      "id": "ec_145c6e5ed1a481edf4232fc1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-41b0-7426-b976-c50de300fde6.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with a welcoming entrance and vibrant flower beds.",
        "public_id": "019d4972-41b0-7426-b976-c50de300fde6",
        "storage_key": "property/6767906449166899/019d4972-41b0-7426-b976-c50de300fde6.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a covered entrance, stone accents, and beautifully landscaped flower gardens that enhance curb appeal.",
      "link": "false",
      "alt_text": "Exterior of apartment building with a welcoming entrance and vibrant flower beds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ClubhouseExteriorCloseUp.jpg"
    },
    {
      "id": "ec_adb9d8812461fd56a698f9c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-4146-7114-ac78-b8e480ac7787.webp",
      "image_media": {
        "alt_text": "Building exterior with a stone chimney and colorful flower beds.",
        "public_id": "019d4972-4146-7114-ac78-b8e480ac7787",
        "storage_key": "property/6767906449166899/019d4972-4146-7114-ac78-b8e480ac7787.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Charming building exterior featuring a rustic stone chimney and vibrant, well-maintained flower beds. A perfect welcome to the community.",
      "link": "false",
      "alt_text": "Building exterior with a stone chimney and colorful flower beds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ClubhouseExterior Landscaping.jpg"
    },
    {
      "id": "ec_f95c0e260730138621f8da9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-419f-700a-b67a-04db07c75eaf.webp",
      "image_media": {
        "alt_text": "Lounge area with kitchen bar and seating near a stone fireplace.",
        "public_id": "019d4972-419f-700a-b67a-04db07c75eaf",
        "storage_key": "property/6767906449166899/019d4972-419f-700a-b67a-04db07c75eaf.webp",
        "width": 2437,
        "height": 1641
      },
      "title": "Community",
      "description": "Gather in the spacious lounge with a well-equipped kitchen bar and comfortable seating areas, perfect for socializing.",
      "link": "false",
      "alt_text": "Lounge area with kitchen bar and seating near a stone fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ClubhouseBar.jpg"
    },
    {
      "id": "ec_18380368c1cbeaec48f63193",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-5c42-7379-9ae2-14f27597ce69.webp",
      "image_media": {
        "alt_text": "Spacious living room with a stone fireplace, comfortable seating, and large windows overlooking greenery.",
        "public_id": "019d4972-5c42-7379-9ae2-14f27597ce69",
        "storage_key": "property/6767906449166899/019d4972-5c42-7379-9ae2-14f27597ce69.webp",
        "width": 2448,
        "height": 1633
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space, featuring a cozy stone fireplace, plush seating, and ample natural light from large windows offering scenic views.",
      "link": "false",
      "alt_text": "Spacious living room with a stone fireplace, comfortable seating, and large windows overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ClubhouseInteriorSeatingAreas.jpg"
    },
    {
      "id": "ec_a0b11ab20999fb338bd91105",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-6089-72f0-9df0-7ceac184889c.webp",
      "image_media": {
        "alt_text": "Living room with stone fireplace, comfortable seating, and TV.",
        "public_id": "019d4972-6089-72f0-9df0-7ceac184889c",
        "storage_key": "property/6767906449166899/019d4972-6089-72f0-9df0-7ceac184889c.webp",
        "width": 2448,
        "height": 1633
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a rustic stone fireplace, plush seating, and a wall-mounted TV, perfect for relaxing evenings.",
      "link": "false",
      "alt_text": "Living room with stone fireplace, comfortable seating, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_ClubhouseFireplace.jpg"
    },
    {
      "id": "ec_9329cd87f25140315633edad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-78c1-766b-bfaa-c9e840d1f621.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stair climbers, and stationary bikes.",
        "public_id": "019d4972-78c1-766b-bfaa-c9e840d1f621",
        "storage_key": "property/6767906449166899/019d4972-78c1-766b-bfaa-c9e840d1f621.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with treadmills, stair climbers, and stationary bikes to help you stay active and healthy.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, stair climbers, and stationary bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_FitnessCenterEquipment(2).jpg"
    },
    {
      "id": "ec_4c683b776c0d4a7c0d55a5d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-78bd-73fe-93a9-18d498bea931.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise equipment in the community gym.",
        "public_id": "019d4972-78bd-73fe-93a9-18d498bea931",
        "storage_key": "property/6767906449166899/019d4972-78bd-73fe-93a9-18d498bea931.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art community fitness center, equipped with cardio machines and weight training equipment.",
      "link": "false",
      "alt_text": "Treadmills and exercise equipment in the community gym.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_FitnessCenterSideView.jpg"
    },
    {
      "id": "ec_f2dd6ffdff9c027042f56676",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-9232-73ff-89bc-f84b5d829f43.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
        "public_id": "019d4972-9232-73ff-89bc-f84b5d829f43",
        "storage_key": "property/6767906449166899/019d4972-9232-73ff-89bc-f84b5d829f43.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, perfect for families and children.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_PlayStructure(2).jpg"
    },
    {
      "id": "ec_cbf71a5d4675a63e4b2e47c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-96ca-7566-aa94-e672fa26b4ba.webp",
      "image_media": {
        "alt_text": "Playground and picnic area with barbecue grill at apartment complex.",
        "public_id": "019d4972-96ca-7566-aa94-e672fa26b4ba",
        "storage_key": "property/6767906449166899/019d4972-96ca-7566-aa94-e672fa26b4ba.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring a barbecue grill and picnic tables, perfect for family gatherings.",
      "link": "false",
      "alt_text": "Playground and picnic area with barbecue grill at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_PicnicArea.jpg"
    },
    {
      "id": "ec_422138532861ed1eab1ab661",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-9e38-705a-9532-2011e32c2f04.webp",
      "image_media": {
        "alt_text": "Community dog park with agility equipment and playground in the background.",
        "public_id": "019d4972-9e38-705a-9532-2011e32c2f04",
        "storage_key": "property/6767906449166899/019d4972-9e38-705a-9532-2011e32c2f04.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment and a playground for children, fostering a vibrant community atmosphere.",
      "link": "false",
      "alt_text": "Community dog park with agility equipment and playground in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_BarkParkPlayground.jpg"
    },
    {
      "id": "ec_551019b9749f61ef074fcc2e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-a166-70ff-ac66-e6e81c870034.webp",
      "image_media": {
        "alt_text": "Dog park with tunnels and agility equipment in front of apartment buildings.",
        "public_id": "019d4972-a166-70ff-ac66-e6e81c870034",
        "storage_key": "property/6767906449166899/019d4972-a166-70ff-ac66-e6e81c870034.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with tunnels and agility equipment, perfect for your furry friend's playtime. Surrounded by lush greenery and apartment homes.",
      "link": "false",
      "alt_text": "Dog park with tunnels and agility equipment in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_BarkPark.jpg"
    },
    {
      "id": "ec_fa4f31e56210cf6c842eac34",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ae-40d9-74b9-8dda-f6b98152025e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawns.",
        "public_id": "019d08ae-40d9-74b9-8dda-f6b98152025e",
        "storage_key": "property/6767906449166899/019d08ae-40d9-74b9-8dda-f6b98152025e.webp",
        "width": 1689,
        "height": 1098
      },
      "title": "Community",
      "description": "Spacious apartment buildings with well-maintained exteriors and lush green lawns, offering a comfortable living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_BuildingExteriorsGreenSpace.jpg"
    },
    {
      "id": "ec_cf4337893530788bb9152c10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-a037-75be-bed9-9253cb09cc36.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and trees",
        "public_id": "019d4972-a037-75be-bed9-9253cb09cc36",
        "storage_key": "property/6767906449166899/019d4972-a037-75be-bed9-9253cb09cc36.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Beautiful exterior view of the apartment complex, showcasing its modern design and lush landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and trees",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_BuildingExteriorPatiosandDecks.jpg"
    },
    {
      "id": "ec_65cca78f06c27c3d7f1453d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d4972-bf70-74ef-aaba-f65f21958677.webp",
      "image_media": {
        "alt_text": "Apartment buildings surrounded by lush green grass and tall trees.",
        "public_id": "019d4972-bf70-74ef-aaba-f65f21958677",
        "storage_key": "property/6767906449166899/019d4972-bf70-74ef-aaba-f65f21958677.webp",
        "width": 1766,
        "height": 1179
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings amidst a beautifully landscaped green space with mature trees.",
      "link": "false",
      "alt_text": "Apartment buildings surrounded by lush green grass and tall trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Pembrooke_Kent_WA_BuildingExteriors.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_28eea62a-8587-45fe-b445-89b61b1f2f14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "17333 Southcenter Pkwy, Tukwila, WA 98188, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches. They also highlight the friendly staff, fast service, and clean dining area with a play area.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-706b-763f-b375-a038d0c70112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-706b-763f-b375-a038d0c70112",
        "storage_key": "property/6767906449166899/019d08af-706b-763f-b375-a038d0c70112.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/southcenter-parkway?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12040570452370729501&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.4479051",
      "poi_longitude": "-122.2631615",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-575-7547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2031-70db-a100-71a96d54e342",
        "storage_key": "property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYi7o3ldkFQRHSqfYgizGKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b0d90b1a-495c-4309-9ac1-4a8a81bf836d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "13 Coins SeaTac",
      "poi_type": "Restaurants",
      "poi_address": "18000 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "Funky eatery serving Italian & American dishes, with high-backed booths & bar seating.",
      "poi_long_description": "People say this restaurant serves delicious chicken parmesan, prime rib, and French onion soup. They also highlight the comfortable booths, the convenient location near the airport, and the friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-7199-7129-a581-18dfa7595be4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7199-7129-a581-18dfa7595be4",
        "storage_key": "property/6767906449166899/019d08af-7199-7129-a581-18dfa7595be4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.13coins.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2627747442472948407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "13-coins-seatac",
      "poi_latitude": "47.44124900000001",
      "poi_longitude": "-122.295415",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-243-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2031-70db-a100-71a96d54e342",
        "storage_key": "property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzbIw6ahckFQRt5IKZGCidyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_33a0c8f9-53a1-4080-a474-f89ef07e83c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "24220 Pacific Hwy S, Kent, WA 98032, USA",
      "poi_short_description": "Part of an old-school chain of fast-food spots offering burgers, fries & hand-dipped shakes.",
      "poi_long_description": "People say this hamburger restaurant serves tasty burgers, fries, and shakes, including a popular deluxe burger and strawberry shake. They highlight the affordable prices and fast service. They also like the classic drive-in vibe and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-7098-7533-a618-178eb4563890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7098-7533-a618-178eb4563890",
        "storage_key": "property/6767906449166899/019d08af-7098-7533-a618-178eb4563890.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://ddir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11821651871694048185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.384308",
      "poi_longitude": "-122.2963598",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-304-5025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2031-70db-a100-71a96d54e342",
        "storage_key": "property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xymCMpbkFQRucunVr7xDqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_61e4c12e-7248-4eb9-92a7-e350b319b98f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Sharps RoastHouse",
      "poi_type": "Restaurants",
      "poi_address": "18427 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "House-roasted meats plus 100s of spirits & beers served under a canopy of bent airplane propellers.",
      "poi_long_description": "People say this restaurant serves delicious pulled pork sandwiches, brisket, and ribs, and offers a variety of other options like rotisserie chicken, prime rib, and fish and chips. They highlight the generous portions, reasonable prices, and convenient location near the airport. They also like the friendly and attentive staff, and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-7199-7129-a581-1c06ffd7d04e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7199-7129-a581-1c06ffd7d04e",
        "storage_key": "property/6767906449166899/019d08af-7199-7129-a581-1c06ffd7d04e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sharpsroasthouse.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058621338899468156&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharps-roasthouse",
      "poi_latitude": "47.4371881",
      "poi_longitude": "-122.2961499",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-241-5744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2031-70db-a100-71a96d54e342",
        "storage_key": "property/6767906449166899/019d08af-2031-70db-a100-71a96d54e342.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFfMjhqdckFQRfE-oQoQdeJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a5d950b7-4c3c-4080-8d88-43b9f9725082",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "601 SW 41st St, Renton, WA 98057, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide selection of high-quality furniture and home decor. They also highlight the affordable prices, friendly and helpful staff, and easy returns.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-76ef-764d-b3e6-7e9115c63ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-76ef-764d-b3e6-7e9115c63ff4",
        "storage_key": "property/6767906449166899/019d08af-76ef-764d-b3e6-7e9115c63ff4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/renton/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=renton",
      "poi_directions_map_url": "https://maps.google.com/?cid=14843228672508442262&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "47.4424006",
      "poi_longitude": "-122.2285737",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-202c-759d-a8cc-156880a064bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-202c-759d-a8cc-156880a064bc",
        "storage_key": "property/6767906449166899/019d08af-202c-759d-a8cc-156880a064bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu15VQR1dkFQRljbCuNW9_c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_080503b3-f8ce-4310-bf18-6ac212d5cfaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "The Outlet Collection Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "1101 Outlet Collection Way, Auburn, WA 98001, USA",
      "poi_short_description": "Large outlet mall featuring brand-name shops for fashion & home goods, plus eateries & kid rides.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including outlets and luxury brands, with good deals and sales. They also highlight the clean facilities, ample parking, and diverse food court with many options.\n\nOther reviews mention some stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-79b0-7659-b066-8509916e75b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-79b0-7659-b066-8509916e75b9",
        "storage_key": "property/6767906449166899/019d08af-79b0-7659-b066-8509916e75b9.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://outletcollectionseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17162083842743284899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-outlet-collection-seattle",
      "poi_latitude": "47.2980791",
      "poi_longitude": "-122.243676",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-833-1790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-202c-759d-a8cc-156880a064bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-202c-759d-a8cc-156880a064bc",
        "storage_key": "property/6767906449166899/019d08af-202c-759d-a8cc-156880a064bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZa-M3GBZkFQRozQvjFP4K-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d38bb946-3288-4da3-ab4d-88634805b19d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "21100 91st Pl S, Kent, WA 98031, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of groceries, including fresh produce, meat, and bulk items, at affordable prices. They also highlight the friendly staff, convenient 24-hour service, and ample parking.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-79bf-71b0-9e2a-e197cc5ee5b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-79bf-71b0-9e2a-e197cc5ee5b6",
        "storage_key": "property/6767906449166899/019d08af-79bf-71b0-9e2a-e197cc5ee5b6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7441409303228944828&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "47.4146395",
      "poi_longitude": "-122.2190107",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-850-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-202b-75c7-be4c-bf1c9ee2c597.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-202b-75c7-be4c-bf1c9ee2c597",
        "storage_key": "property/6767906449166899/019d08af-202b-75c7-be4c-bf1c9ee2c597.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRR5LkFckFQRvJE_w1UyRWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_4c8c9a22-5056-4c43-903b-35476d17a9f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Kent Station Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "417 Ramsay Way, Kent, WA 98032, USA",
      "poi_short_description": "Traditional shopping center offering a variety of shops, services, restaurants, cafes & a cinema.",
      "poi_long_description": "Traditional shopping center offering a variety of shops, services, restaurants, cafes & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ae-bf82-77a7-95b1-cf65a6b25f93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-bf82-77a7-95b1-cf65a6b25f93",
        "storage_key": "property/6767906449166899/019d08ae-bf82-77a7-95b1-cf65a6b25f93.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kentstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11371983263310072599&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kent-station-shopping-center",
      "poi_latitude": "47.3844514",
      "poi_longitude": "-122.2351387",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-856-2301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-202c-759d-a8cc-156880a064bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-202c-759d-a8cc-156880a064bc",
        "storage_key": "property/6767906449166899/019d08af-202c-759d-a8cc-156880a064bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsaj04_5bkFQRF8tI0YZm0Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_385f4d7f-21e7-47c1-a0c9-25f2122a01a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "H Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "31217 Pacific Hwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Large market stocking Asian groceries, including housewares, seafood and fresh produce.",
      "poi_long_description": "Shoppers say this Korean grocery store offers a wide variety of fresh produce, seafood, and Asian groceries, including kimchi, sauces, and ramen. They also highlight the friendly staff, clean environment, and convenient food court with delicious hot food options.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-7d13-7419-83c0-60f76377da06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7d13-7419-83c0-60f76377da06",
        "storage_key": "property/6767906449166899/019d08af-7d13-7419-83c0-60f76377da06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hmartus.com/federalway",
      "poi_directions_map_url": "https://maps.google.com/?cid=4688323470681939457&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart",
      "poi_latitude": "47.3218808",
      "poi_longitude": "-122.3152936",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-528-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-202b-75c7-be4c-bf1c9ee2c597.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-202b-75c7-be4c-bf1c9ee2c597",
        "storage_key": "property/6767906449166899/019d08af-202b-75c7-be4c-bf1c9ee2c597.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4-TAXtXkFQRAZ4fVltFEEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_0d3ed0b0-6c17-4945-b245-2a4a4bb05d64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Highline College",
      "poi_type": "Education",
      "poi_address": "2400 S 240th St, Des Moines, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-7f36-77e7-a1dc-5202bfb67a72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7f36-77e7-a1dc-5202bfb67a72",
        "storage_key": "property/6767906449166899/019d08af-7f36-77e7-a1dc-5202bfb67a72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.highline.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9102534943473461902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "highline-college",
      "poi_latitude": "47.38833469999999",
      "poi_longitude": "-122.3017666",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-878-3710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24fa-7208-a243-53a917deea5e",
        "storage_key": "property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0oT_BNDkFQRjupQxU2zUn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a55a8869-6f1e-4ff3-956f-6e3dc15bf4cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Federal Way Library",
      "poi_type": "Education",
      "poi_address": "34200 1st Way S, Federal Way, WA 98003, USA",
      "poi_short_description": "Well-kept library with a spacious layout and a selection of books, plus quiet study nooks and public computers.",
      "poi_long_description": "People say this public library offers computers, meeting rooms, and private study rooms. They highlight the quiet and comfortable atmosphere, and the accessible and available computers. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-7f36-77e7-a1dc-567d6daab81f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7f36-77e7-a1dc-567d6daab81f",
        "storage_key": "property/6767906449166899/019d08af-7f36-77e7-a1dc-567d6daab81f.webp",
        "width": 1200,
        "height": 640
      },
      "poi_business_url": "https://kcls.org/locations/federal-way/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16551526452281979999&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-way-library",
      "poi_latitude": "47.2946347",
      "poi_longitude": "-122.3318011",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-838-3668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24fa-7208-a243-53a917deea5e",
        "storage_key": "property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxUUM1bNXkFQRX7S_Vp3VsuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c92b0bb5-391d-400a-88aa-bc4add9faa74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Kent Library",
      "poi_type": "Education",
      "poi_address": "212 2nd Ave N, Kent, WA 98032, USA",
      "poi_short_description": "Public library offering a good selection of books, as well as computers and events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-8073-7730-8ab8-16b06ec8378a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8073-7730-8ab8-16b06ec8378a",
        "storage_key": "property/6767906449166899/019d08af-8073-7730-8ab8-16b06ec8378a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcls.org/locations/1520/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1964910656879285583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kent-library",
      "poi_latitude": "47.3826063",
      "poi_longitude": "-122.2342107",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-859-3330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24fa-7208-a243-53a917deea5e",
        "storage_key": "property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi69Y9VVZkFQRT1Wr9tTDRBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_787d73df-ad5e-445c-91be-e36136d0b483",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "accesso ShoWare Center",
      "poi_type": "Entertainment",
      "poi_address": "625 W James St, Kent, WA 98032, USA",
      "poi_short_description": "6,500-seat arena that's home to the Seattle Thunderbirds & concerts by nationally known acts.",
      "poi_long_description": "People say this arena offers exciting concerts and hockey games. They also highlight the free parking, quick security lines, and well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ae-bf46-71ac-b1d5-5a69d90ea8ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-bf46-71ac-b1d5-5a69d90ea8ff",
        "storage_key": "property/6767906449166899/019d08ae-bf46-71ac-b1d5-5a69d90ea8ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.accessoshowarecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9935684235218299410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "accesso-showare-center",
      "poi_latitude": "47.3870253",
      "poi_longitude": "-122.2398816",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-856-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJea31XvlbkFQREqqioCuk4ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_96ea9215-297d-4cba-9480-9e808425c66d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Pacific Bonsai Museum",
      "poi_type": "Entertainment",
      "poi_address": "2515 South 336th St, Federal Way, WA 98003, USA",
      "poi_short_description": "This collection boasts over 100 bonsai trees from China, Japan, Canada, Korea, Taiwan & America.",
      "poi_long_description": "People say this museum offers a stunning collection of bonsai trees, with informative plaques detailing their history and cultivation. They highlight the peaceful and tranquil atmosphere, and the easy access and well-maintained grounds. They also like the free admission and the option to donate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-8636-76d9-8368-95f50eaaac35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8636-76d9-8368-95f50eaaac35",
        "storage_key": "property/6767906449166899/019d08af-8636-76d9-8368-95f50eaaac35.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pacificbonsaimuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4045163731685863932&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacific-bonsai-museum",
      "poi_latitude": "47.29383379999999",
      "poi_longitude": "-122.3020013",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-353-7345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2585-768b-a4b5-b36b9509e084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2585-768b-a4b5-b36b9509e084",
        "storage_key": "property/6767906449166899/019d08af-2585-768b-a4b5-b36b9509e084.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wDOE45XkFQR_PFtVftOIzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f1a597b8-1ca0-4232-99a0-97f183db8faa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Federal Way Memorial Field",
      "poi_type": "Entertainment",
      "poi_address": "1300 S 308th St, Federal Way, WA 98003, USA",
      "poi_short_description": "Stadium primarily used for track and field and football, with concessions and clean bathrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-8636-76d9-8368-98ce0a082b1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8636-76d9-8368-98ce0a082b1c",
        "storage_key": "property/6767906449166899/019d08af-8636-76d9-8368-98ce0a082b1c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.fwps.org/departments/athletics/contacts",
      "poi_directions_map_url": "https://maps.google.com/?cid=6511868263936655215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-way-memorial-field",
      "poi_latitude": "47.3275774",
      "poi_longitude": "-122.3170758",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 253-945-5575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-bbd6-7328-9b19-c0d55d23313e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-bbd6-7328-9b19-c0d55d23313e",
        "storage_key": "property/6767906449166899/019d08af-bbd6-7328-9b19-c0d55d23313e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuQhCiWRXkFQRb38VSK_NXlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_d803882f-2379-41f8-921e-c39b99f33231",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "MaST Center Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "28203 Redondo Beach Dr S, Des Moines, WA 98198, USA",
      "poi_short_description": "Highline College's marine biology center features an aquarium housing over 250 native species.",
      "poi_long_description": "Highline College's marine biology center features an aquarium housing over 250 native species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-8636-76d9-8368-909fbc7f8e53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8636-76d9-8368-909fbc7f8e53",
        "storage_key": "property/6767906449166899/019d08af-8636-76d9-8368-909fbc7f8e53.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://mast.highline.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16904469704262291670&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mast-center-aquarium",
      "poi_latitude": "47.3488707",
      "poi_longitude": "-122.324405",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-592-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2yUWflZkFQR1hDo3qG9mOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_c934df9f-5c2b-44d1-9292-48a413a91f49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "French Field",
      "poi_type": "Entertainment",
      "poi_address": "10020 SE 256th St, Kent, WA 98030, USA",
      "poi_short_description": "Stadium used by Kent-area high schools for football games and track meets.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-88a5-7229-ae88-3bed5737cb94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-88a5-7229-ae88-3bed5737cb94",
        "storage_key": "property/6767906449166899/019d08af-88a5-7229-ae88-3bed5737cb94.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8125421312583600403&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "french-field",
      "poi_latitude": "47.3746889",
      "poi_longitude": "-122.2090829",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-373-7251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-bbd6-7328-9b19-c0d55d23313e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-bbd6-7328-9b19-c0d55d23313e",
        "storage_key": "property/6767906449166899/019d08af-bbd6-7328-9b19-c0d55d23313e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFao2XbZekFQREwnvKqJLw3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c673d109-290a-4ab3-b232-6be276a240aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "20600 108th Ave SE, Kent, WA 98031, USA",
      "poi_short_description": "Fitness chain featuring strength-training equipment, cardio machines, and a pool, plus yoga classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including Olympic squat racks, dumbbells, cable machines, cardio equipment, and saunas, and has a friendly and helpful staff.\n\nOther reviews mention the facilities can be poorly maintained and the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-8dd2-76aa-8e68-062f00e84f38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8dd2-76aa-8e68-062f00e84f38",
        "storage_key": "property/6767906449166899/019d08af-8dd2-76aa-8e68-062f00e84f38.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/kent-wa/panther-lake-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17830706196700204591&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.41731170000001",
      "poi_longitude": "-122.1952027",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-220-2342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRnmjBRdkFQRLw6slNBkc_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2a04841b-aabc-4378-b048-5236782833c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "35009 Enchanted Pkwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Spacious, clean athletic facility featuring a wide variety of equipment and classes, plus a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-8dfc-71f9-9613-e0a72702f771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8dfc-71f9-9613-e0a72702f771",
        "storage_key": "property/6767906449166899/019d08af-8dfc-71f9-9613-e0a72702f771.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=325&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18330114516273239084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.2877945",
      "poi_longitude": "-122.315461",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-838-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4MOHcZXkFQRLJSyEgmmYf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7839a9b8-eb0e-4d9c-9030-9a6d8f31c5e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Matt Griffin YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3595 S 188th St, SeaTac, WA 98188, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Visitors say this gym has a great pool with warm, clean water and excellent swim instructors. They also highlight the spacious layout, solid equipment, and friendly atmosphere.\n\nSome reviews mention the pool can be frequently closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-8f86-73b8-925b-57e7db797053.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-8f86-73b8-925b-57e7db797053",
        "storage_key": "property/6767906449166899/019d08af-8f86-73b8-925b-57e7db797053.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattleymca.org/locations/matt-griffin-ymca?utm_source=google&utm_medium=organic&utm_campaign=business-listing&utm_content=matt-griffin",
      "poi_directions_map_url": "https://maps.google.com/?cid=4772808112517058483&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "matt-griffin-ymca",
      "poi_latitude": "47.4337385",
      "poi_longitude": "-122.2882906",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-244-5880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5n-BKFckFQRs4-u37BrPEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0499422c-672e-4689-b2df-3a40e5c8a328",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1211 S 320th St, Federal Way, WA 98003, USA",
      "poi_short_description": "Planet Fitness chain with a spacious workout floor, plus massages, tanning booths and helpful front-desk staff.",
      "poi_long_description": "People say this gym offers a variety of workout equipment and massage chairs. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.\n\nOther reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ae-e5a0-724f-bcb8-6b0f6d8152a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-e5a0-724f-bcb8-6b0f6d8152a9",
        "storage_key": "property/6767906449166899/019d08ae-e5a0-724f-bcb8-6b0f6d8152a9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/federal-way-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16903145690203903254&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.3136755",
      "poi_longitude": "-122.3166133",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-429-7429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnX_yPnZXkFQRFlVH03IJlOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_568542a5-7b05-4438-bc68-26409ce365eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "17320 Southcenter Pkwy, Tukwila, WA 98188, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-9495-749f-969d-461ad590c356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-9495-749f-969d-461ad590c356",
        "storage_key": "property/6767906449166899/019d08af-9495-749f-969d-461ad590c356.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tukwila-wa-191",
      "poi_directions_map_url": "https://maps.google.com/?cid=15091536541923712576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "47.448395",
      "poi_longitude": "-122.2611342",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-575-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5TsiXVdkFQRQJ4wyIbob9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_96256c56-cf60-4089-82d8-4fb8aae2137d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Metropolitan Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6822 S 190th St, Kent, WA 98032, USA",
      "poi_short_description": "Toddler-friendly gymnastics center providing classes and competitive team opportunities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-96ea-713c-b1af-a72bddb24a6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-96ea-713c-b1af-a72bddb24a6c",
        "storage_key": "property/6767906449166899/019d08af-96ea-713c-b1af-a72bddb24a6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://metropolitangym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093236913196072024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metropolitan-gymnastics",
      "poi_latitude": "47.4328435",
      "poi_longitude": "-122.2477764",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-282-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24fa-7208-a243-53a917deea5e",
        "storage_key": "property/6767906449166899/019d08af-24fa-7208-a243-53a917deea5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnWcqiO1ckFQRWHz1x_zPrkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fa6a605c-1c36-41bd-bb19-8c7f59b144d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Fitness Quest MMA",
      "poi_type": "Health and Wellness",
      "poi_address": "1101 Outlet Collection Way #1275, Auburn, WA 98001, USA",
      "poi_short_description": "A full-service gym offering group classes and personal training alike.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-9841-7735-a05e-17b6aca63219.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-9841-7735-a05e-17b6aca63219",
        "storage_key": "property/6767906449166899/019d08af-9841-7735-a05e-17b6aca63219.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://fitness-quest-mma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6673923412006407803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-quest-mma",
      "poi_latitude": "47.3000884",
      "poi_longitude": "-122.2443359",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-737-5829",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5badbBRZkFQRew7OtvuJnlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d172bf46-8540-48fe-99a0-5e3070b99089",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "MultiCare Auburn Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "202 N Division St, Auburn, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-19ef-71aa-a5d7-443274ecab6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-19ef-71aa-a5d7-443274ecab6f",
        "storage_key": "property/6767906449166899/019d08af-19ef-71aa-a5d7-443274ecab6f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.multicare.org/location/auburn-medical-center/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11639181374272454319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "multicare-auburn-medical-center",
      "poi_latitude": "47.3091229",
      "poi_longitude": "-122.2292207",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-833-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2a2c-75cf-aa09-ab4a1c2fb0a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2a2c-75cf-aa09-ab4a1c2fb0a4",
        "storage_key": "property/6767906449166899/019d08af-2a2c-75cf-aa09-ab4a1c2fb0a4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfXuti29YkFQRrz7a-cqthqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1daa5df3-cc2f-4c67-beed-c8f9a009bfd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Virginia Mason Federal Way Urgent Care Walk-in Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "33501 1st Way S, Federal Way, WA 98003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.vmfh.org/find-a-location/virginia-mason-federal-way-urgent-care-walk-in-clinic-6735721",
      "poi_directions_map_url": "https://maps.google.com/?cid=5226908930765764498&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "virginia-mason-federal-way-urgent-care-walk-in-clinic",
      "poi_latitude": "47.3005137",
      "poi_longitude": "-122.3308669",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-838-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2a2c-75cf-aa09-ab4a1c2fb0a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2a2c-75cf-aa09-ab4a1c2fb0a4",
        "storage_key": "property/6767906449166899/019d08af-2a2c-75cf-aa09-ab4a1c2fb0a4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yYRBCdXkFQRkjecq_q1iUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5a696a3e-d6e5-4eea-9a99-c7165742649c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Saltwater State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "25205 8th Pl S, Des Moines, WA 98198, USA",
      "poi_short_description": "This park on the shores of Puget Sound has campsites, volleyball courts & an artificial reef.",
      "poi_long_description": "People say this state park offers a beautiful beach, hiking trails, and opportunities to explore sea life at low tide. They highlight the peaceful and relaxing vibe, and the availability of amenities such as picnic tables, restrooms, and a playground. They also like the ample parking and the option to bring dogs on leash.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-9d36-71ef-9b57-517122d1f0ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-9d36-71ef-9b57-517122d1f0ee",
        "storage_key": "property/6767906449166899/019d08af-9d36-71ef-9b57-517122d1f0ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://parks.state.wa.us/578/Saltwater",
      "poi_directions_map_url": "https://maps.google.com/?cid=6985291121296586622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saltwater-state-park",
      "poi_latitude": "47.3758089",
      "poi_longitude": "-122.3231043",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 253-661-4956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2a17-74b4-9e32-55ad14c069ac",
        "storage_key": "property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36mzLDlakFQRfreS4UO98GA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_e4e44393-60e8-48d9-8499-5c5199949a22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Angle Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19408 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "This green space with a lake offers amenities such as a boat launch, playground & water spray park.",
      "poi_long_description": "People say this park offers a lake for swimming, fishing, and boating, as well as a splash pad, playground, and picnic areas. They highlight the beautiful lake views, the ample grassy areas for playing and relaxing, and the availability of lifeguards during the summer. They also like the paved walkways, the easy beach access, and the presence of wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-9d9c-71ed-8bcb-22b38dbcdd32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-9d9c-71ed-8bcb-22b38dbcdd32",
        "storage_key": "property/6767906449166899/019d08af-9d9c-71ed-8bcb-22b38dbcdd32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seatacwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10463006071752659881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "angle-lake-park",
      "poi_latitude": "47.428313",
      "poi_longitude": "-122.294627",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-973-4680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2a17-74b4-9e32-55ad14c069ac",
        "storage_key": "property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7NCsWBbkFQRqZOSPZYQNJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2aede09f-ce15-4dc5-92bf-99769822555f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Steel Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2410 S 312th St, Federal Way, WA 98003, USA",
      "poi_short_description": "This 52-acre, lakeside park offers a playground & volleyball pit, plus live summertime concerts.",
      "poi_long_description": "People say this city park offers a spacious layout, plenty of play structures, and beautiful natural surroundings, including a lake, dock, and beach. They highlight the family-friendly atmosphere, the variety of things for kids to climb, explore, and enjoy, and the relaxing atmosphere created by the lake and greenery. They also like the ample parking, picnic tables, and open grass areas, perfect for gatherings and barbecues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-a096-7039-85b1-54880ff95b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-a096-7039-85b1-54880ff95b22",
        "storage_key": "property/6767906449166899/019d08af-a096-7039-85b1-54880ff95b22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cityoffederalway.com/page/community-parks-0",
      "poi_directions_map_url": "https://maps.google.com/?cid=11880846663345183193&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "steel-lake-park",
      "poi_latitude": "47.32237809999999",
      "poi_longitude": "-122.300183",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-835-6964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2a17-74b4-9e32-55ad14c069ac",
        "storage_key": "property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNY7k8tVZkFQR2RmTxxc_4aQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_764ee7db-3873-4893-a853-c060b10b614d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Riverbend Golf Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2019 W Meeker St, Kent, WA 98032, USA",
      "poi_short_description": "Golf facility featuring a mix of par 3s, 4s, and 5s, plus a driving range and putting green.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08ae-c987-7249-9128-c96edd69d927.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-c987-7249-9128-c96edd69d927",
        "storage_key": "property/6767906449166899/019d08ae-c987-7249-9128-c96edd69d927.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.riverbendgolfcomplex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10603289259318517293&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverbend-golf-complex",
      "poi_latitude": "47.38081",
      "poi_longitude": "-122.262864",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 253-854-3673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-29dc-777b-8256-489e3c60c12e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-29dc-777b-8256-489e3c60c12e",
        "storage_key": "property/6767906449166899/019d08af-29dc-777b-8256-489e3c60c12e.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJURkbaedbkFQRLR5lGGdzJpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_6eadeda2-1e5c-43d4-ae6e-2bbb8c995b87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Valley Ridge Community Center & Ball Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4644 S 188th St, SeaTac, WA 98188, USA",
      "poi_short_description": "Neighborhood hub with a community center, skate park, playground & ball fields with synthetic turf.",
      "poi_long_description": "People say this park offers turf fields with lights, a playground, and a skate park. They highlight the well-maintained facilities, including basketball and tennis courts, walking trails, and shaded areas. They also like the convenient amenities, such as bathrooms and parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-a165-747b-871d-882652004665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-a165-747b-871d-882652004665",
        "storage_key": "property/6767906449166899/019d08af-a165-747b-871d-882652004665.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seatacwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15774027189329069139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "valley-ridge-community-center--ball-fields",
      "poi_latitude": "47.4352797",
      "poi_longitude": "-122.2743987",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-973-4680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2a17-74b4-9e32-55ad14c069ac",
        "storage_key": "property/6767906449166899/019d08af-2a17-74b4-9e32-55ad14c069ac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XRjSL1ckFQRUwRQgSea6No",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_61800ec8-ee85-4f51-ac9c-058bb4c44a8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Seattle–Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-09d7-7272-80f2-e9808ff0e727.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-09d7-7272-80f2-e9808ff0e727",
        "storage_key": "property/6767906449166899/019d08af-09d7-7272-80f2-e9808ff0e727.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattletacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-787-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2fb8-75bb-8b4c-10aa629c3ab1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2fb8-75bb-8b4c-10aa629c3ab1",
        "storage_key": "property/6767906449166899/019d08af-2fb8-75bb-8b4c-10aa629c3ab1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_a0013010-5eaf-4e16-889b-dbcc30c07762",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Angle Lake",
      "poi_type": "Transportation & Transit",
      "poi_address": "SeaTac, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-a5a8-7086-abcf-e1afaa3b8e81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-a5a8-7086-abcf-e1afaa3b8e81",
        "storage_key": "property/6767906449166899/019d08af-a5a8-7086-abcf-e1afaa3b8e81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15554939121471465518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "angle-lake",
      "poi_latitude": "47.4223163",
      "poi_longitude": "-122.2978013",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSKHS29bkFQRLigiprc-3tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_3c23e331-78a7-4bfe-8e4b-446155e3bc42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Kent",
      "poi_type": "Transportation & Transit",
      "poi_address": "301 Railroad Ave N, Kent, WA 98032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-06f6-760f-80e6-cb0474ca644e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-06f6-760f-80e6-cb0474ca644e",
        "storage_key": "property/6767906449166899/019d08af-06f6-760f-80e6-cb0474ca644e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Kent-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8298822110823561671&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kent",
      "poi_latitude": "47.3845727",
      "poi_longitude": "-122.2329171",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2f86-73c4-943a-735402ecc187.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2f86-73c4-943a-735402ecc187",
        "storage_key": "property/6767906449166899/019d08af-2f86-73c4-943a-735402ecc187.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2fjpP9bkFQRx7nLob1WK3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_52109ffb-c26b-4bd3-9499-b6a6516a4001",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Auburn Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2143 E St NE Suite 1, Auburn, WA 98002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://auburnmunicipalairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15666029001133359872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn-municipal-airport",
      "poi_latitude": "47.3261957",
      "poi_longitude": "-122.2242996",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-333-6821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2fb8-75bb-8b4c-10aa629c3ab1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2fb8-75bb-8b4c-10aa629c3ab1",
        "storage_key": "property/6767906449166899/019d08af-2fb8-75bb-8b4c-10aa629c3ab1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWoKJ_dYkFQRAIOF1V_qaNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b74174ea-54ee-4847-8b51-b62beaba9238",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Auburn",
      "poi_type": "Transportation & Transit",
      "poi_address": "Auburn, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-a84d-7405-b3cb-2bc051bf3844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-a84d-7405-b3cb-2bc051bf3844",
        "storage_key": "property/6767906449166899/019d08af-a84d-7405-b3cb-2bc051bf3844.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Auburn-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1259782787896726413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn",
      "poi_latitude": "47.3065308",
      "poi_longitude": "-122.2320834",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-2f86-73c4-943a-735402ecc187.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-2f86-73c4-943a-735402ecc187",
        "storage_key": "property/6767906449166899/019d08af-2f86-73c4-943a-735402ecc187.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1af5nFYkFQRjVO8XsWlexE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_ba8c9880-f243-4d9a-8a9b-040a3a711997",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "FAA Bldg",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 S 216th St, Des Moines, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-a84c-737a-b2c8-339143d3c87b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-a84c-737a-b2c8-339143d3c87b",
        "storage_key": "property/6767906449166899/019d08af-a84c-737a-b2c8-339143d3c87b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.faa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523186749664561825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "faa-bldg",
      "poi_latitude": "47.4093889",
      "poi_longitude": "-122.3054526",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-231-3828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzNAhgxbkFQRoYryrJO7Qgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a52a5a34-52fe-40d6-912d-111409f3b211",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Alaska Airlines - McGee Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20313 28th Ave S, SeaTac, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-ab0f-712c-9ad7-fc2931f4428e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-ab0f-712c-9ad7-fc2931f4428e",
        "storage_key": "property/6767906449166899/019d08af-ab0f-712c-9ad7-fc2931f4428e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.alaskaair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18272394773360131008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alaska-airlines---mcgee-building",
      "poi_latitude": "47.4199425",
      "poi_longitude": "-122.2975144",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-433-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bqy-G5bkFQRwLvVLTyWlP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d6142c97-1e5a-427d-8cc4-bc3091e739a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Boeing Building 17-70",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Perimeter Rd, Auburn, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-acfb-72c1-8eb8-f5e042dbf79c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-acfb-72c1-8eb8-f5e042dbf79c",
        "storage_key": "property/6767906449166899/019d08af-acfb-72c1-8eb8-f5e042dbf79c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4152677144536151503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boeing-building-17-70",
      "poi_latitude": "47.2882995",
      "poi_longitude": "-122.2422463",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-657-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_EMQPH3kFQRz_X1ctxFoTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5f2bbcab-e9a5-44b9-94b9-eb760251307b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "DaVita Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3201 S 323rd St, Federal Way, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-b042-77aa-b9af-441ecaf8a140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-b042-77aa-b9af-441ecaf8a140",
        "storage_key": "property/6767906449166899/019d08af-b042-77aa-b9af-441ecaf8a140.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://davita.com/about/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=1368784550882395259&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "davita-corporate-office",
      "poi_latitude": "47.3113754",
      "poi_longitude": "-122.2929799",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-733-4602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-24f3-726a-8eb2-3912ab83f3bf",
        "storage_key": "property/6767906449166899/019d08af-24f3-726a-8eb2-3912ab83f3bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6Zz9oZXkFQRe0RjAUzm_hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4bc0afa3-9883-4920-9dbd-fb2ca258ca76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "poi_name": "Federal Way City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "33325 8th Ave S, Federal Way, WA 98003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-b1ad-74ac-a3ea-72311eec7dc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-b1ad-74ac-a3ea-72311eec7dc8",
        "storage_key": "property/6767906449166899/019d08af-b1ad-74ac-a3ea-72311eec7dc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityoffederalway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12254893830259000528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-way-city-hall",
      "poi_latitude": "47.3040068",
      "poi_longitude": "-122.32649",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-835-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d08af-33cc-704b-b9d6-b3ae8b4e1a5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-33cc-704b-b9d6-b3ae8b4e1a5c",
        "storage_key": "property/6767906449166899/019d08af-33cc-704b-b9d6-b3ae8b4e1a5c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYCoHKRXkFQR0MS2aAIhEqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f98ff0a5-c7f0-4d14-9ae0-7578d1bd837b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_fac5d85b-da18-4125-8ebb-36e1c04a7711",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_cdeabacc-3298-43d8-a17d-6a9837edb8cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_9c7dc4ad-21c4-4ba5-b309-46768c2627f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_77e30f00-b229-4225-926a-f2cdecc14441",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_956aa6fc-393e-4daa-be3a-4be4de6394dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_7b451739-917d-45bb-8879-aa81bcd5f368",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_e6ff8a57-a8c5-44b5-84d1-62f64ac40f7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "rating": "5.0",
      "name": "Jessica Ramos Cortes",
      "text": "The apartments are very clean and quiet, office people are always personable and helpful. Appliaces are new with a vintage look. Great apartments overall.",
      "date": "2018-07-02",
      "title": ""
    },
    {
      "id": "custom_014a5f88-2018-425f-a63c-96e668825446",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "rating": "5.0",
      "name": "Katie Eagleson",
      "text": "These are the best apartments my husband and I have lived in. The office staff and maintenance guys are always there when we have needed something, very kind and knowledgeable, and I have honestly never had an issue with them. Sure, parking sucks but we have our spots and we have no issue parking. Gabby, the apartment manager, is the sweetest and I always laugh when I have to call to ask about something, very easy to talk to and not at all slumlord like. Very happy to call this place home for the foreseeable future.",
      "date": "2018-09-27",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7dd84a67-122c-4cae-ab14-00b8697774fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d2c29-e0fb-70bb-a9b4-ee1e5a511da9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c29-e0fb-70bb-a9b4-ee1e5a511da9",
        "storage_key": "property/6767906449166899/019d2c29-e0fb-70bb-a9b4-ee1e5a511da9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pembrooke Apartments - 1 Bedroom 1 Bath 636 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EdhisCk76vX"
    },
    {
      "id": "custom_d822393d-a4be-4e25-afad-82de651dac5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d2c29-f992-72a8-b772-395bef0aeb7b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c29-f992-72a8-b772-395bef0aeb7b",
        "storage_key": "property/6767906449166899/019d2c29-f992-72a8-b772-395bef0aeb7b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pembrooke Apartments - 2 Bedroom 1 Bath 840 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tJvKZ4rPPxB"
    },
    {
      "id": "custom_fd1ba877-8a7d-48a5-974c-e12cfad3c63a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d2c2a-102f-7679-bd42-5b419f7103d3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c2a-102f-7679-bd42-5b419f7103d3",
        "storage_key": "property/6767906449166899/019d2c2a-102f-7679-bd42-5b419f7103d3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pembrooke Apartments - 2 Bedroom 2 Bath 876 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cmKv1VHToAF"
    },
    {
      "id": "custom_01ee46c8-a60d-4edd-8bf8-40ceb3ba7e47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d2c2a-2dcb-77dd-96a7-18edffda345f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c2a-2dcb-77dd-96a7-18edffda345f",
        "storage_key": "property/6767906449166899/019d2c2a-2dcb-77dd-96a7-18edffda345f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pembrooke Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8fZandfwZRf"
    },
    {
      "id": "custom_70ce64f7-2caa-41fd-b345-48be7af1d560",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166899/019d2c2a-4cfc-771f-b585-492af008ed4a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c2a-4cfc-771f-b585-492af008ed4a",
        "storage_key": "property/6767906449166899/019d2c2a-4cfc-771f-b585-492af008ed4a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pembrooke Apartments - Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UVfZvpNpTuL"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db136-5b19-7718-8e9f-b905ba30bf4c",
      "lead_source": "LANDING_PAGE",
      "name": "Pembrooke Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-kent-wa",
      "search_query": "pet friendly apartments in Kent WA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Kent WA",
      "h2_subtitle": "Discover pet welcoming homes at Pembrooke Apartments. Enjoy a community designed with both you and your furry friends in mind.",
      "page_copy": "At Pembrooke Apartments, we understand that pets are part of the family, which is why our community is proud to offer pet friendly apartments in Kent WA. Nestled in King County, our smoke free housing ensures a healthy environment for both you and your pets. \n\nOur amenities are designed to enhance your lifestyle, featuring a jogging trail perfect for leisurely strolls with your pet and an outdoor seasonal pool for relaxation. With convenient online rent payments and 24-hour package lockers, you’ll have more time to spend enjoying moments with your furry companions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Kent WA",
      "seo_description": "Explore pet friendly apartments at Pembrooke Apartments in Kent, WA. Perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-king-county",
      "search_query": "apartments with fitness center in King County",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in King County",
      "h2_subtitle": "Find the perfect balance of comfort and fitness at Pembrooke Apartments. Enjoy a community designed with an active lifestyle in mind.",
      "page_copy": "Although Pembrooke Apartments doesn't feature a traditional fitness center, residents can still maintain an active lifestyle through various amenities. Our community in King County boasts a scenic jogging trail, ideal for morning runs or leisurely walks. \n\nThese apartments offer smoke free living and a variety of conveniences including online rent payments and 24-hour package lockers, freeing up more time for your active pursuits. Embrace a lifestyle of health and convenience with Pembrooke Apartments, a prime location in Kent, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in King County",
      "seo_description": "Explore active living at Pembrooke Apartments in King County. Ideal for pursuing health and comfort in Kent, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-with-pool-kent-98032",
      "search_query": "apartments with a pool in Kent 98032",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Kent 98032",
      "h2_subtitle": "Enjoy refreshing summers at Pembrooke Apartments, featuring an outdoor seasonal pool in Kent's vibrant 98032 area.",
      "page_copy": "Dive into comfort at Pembrooke Apartments, where our outdoor seasonal pool offers the perfect retreat from busy days in Kent, 98032. Our community is more than just a place to live; it's a place where you can unwind and enjoy. \n\nLocated in King County, our pet-friendly apartments provide a smoke free environment, ensuring both wellness and relaxation. With conveniences like online rent payments and 24-hour package lockers, living here means more time to soak up the sun by the poolside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Kent 98032",
      "seo_description": "Discover apartments with a pool at Pembrooke Apartments, Kent 98032. Relax and enjoy community amenities in King County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "dog-park-apartments-kent-wa",
      "search_query": "dog park apartments Kent WA",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Kent WA",
      "h2_subtitle": "Experience pet-friendly living at Pembrooke Apartments in Kent, WA. Enjoy amenities that cater to your four-legged companions.",
      "page_copy": "While Pembrooke Apartments does not feature an on-site dog park, our community offers numerous pet-friendly amenities in Kent, WA. We provide a scenic jogging trail, perfect for exhilarating runs and leisurely walks with your furry friend. \n\nLocated in the heart of Kent, our smoke free apartments ensure a healthy lifestyle for both you and your pets. Additional conveniences, such as online rent payments and 24-hour package lockers, make living at Pembrooke Apartments a delight. King County’s natural beauty further enhances the experience for all pet lovers here.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Kent WA",
      "seo_description": "Explore pet-friendly living at Pembrooke Apartments in Kent, WA. Ideal for dogs and owners, with amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "multifamily-housing-package-lockers-king-county",
      "search_query": "multifamily housing with package lockers in King County",
      "category": "Amenity",
      "h1_title": "Multifamily Housing with Package Lockers",
      "h2_subtitle": "Find convenience at Pembrooke Apartments in King County, offering secure 24-hour package lockers in our multifamily housing community.",
      "page_copy": "Located in King County, Pembrooke Apartments is a premier choice for those seeking multifamily housing with modern conveniences. Our community is equipped with secure 24-hour package lockers, ensuring your deliveries are safe and accessible at any time.\n\nBesides the package lockers, residents enjoy benefits such as smoke free living, outdoor recreational options like a jogging trail and seasonal pool, and the ease of online rent payments. At Pembrooke Apartments in Kent, you'll find a blend of comfort and practicality suited for today's busy lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Multifamily Housing with Package Lockers",
      "seo_description": "Discover Pembrooke Apartments in King County, WA with secure package lockers, ideal for modern living in a multifamily community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-kent-wa",
      "search_query": "one bedroom apartments kent wa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Kent, WA",
      "h2_subtitle": "Explore the comfort of one-bedroom apartments at Pembrooke Apartments in Kent, WA. Enjoy cozy living with modern amenities.",
      "page_copy": "Settle into one of our meticulously designed one-bedroom apartments at Pembrooke Apartments, located in the vibrant community of Kent, WA. Each unit offers a perfect blend of style and functionality, ideal for singles or couples looking to make a home in King County.\n\nPembrooke Apartments enhances everyday living with conveniences such as a smoke free environment, online rent payments, and 24-hour package lockers. Plus, take advantage of recreational amenities like the jogging trail and outdoor seasonal pool. Discover the perfect mix of urban accessibility and suburban tranquility in Kent with a one-bedroom unit tailored just for you.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Kent, WA",
      "seo_description": "Find comfortable one-bedroom apartments at Pembrooke in Kent, WA. Enjoy modern living with convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-king-county",
      "search_query": "two bedroom apartments near king county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near King County",
      "h2_subtitle": "Discover spacious two-bedroom apartments at Pembrooke Apartments, conveniently located near King County, WA.",
      "page_copy": "Pembrooke Apartments offers spacious two-bedroom units, ideally situated near the bustling surrounds of King County. These apartments provide ample space, perfect for families, roommates, or those needing extra room to breathe. Each unit combines comfort and practicality, making them an ideal choice for those wanting a sense of community coupled with privacy.\n\nOur property in Kent features essential amenities like a jogging trail, outdoor seasonal pool, and smoke free living environment. Residents also enjoy the convenience of online rent payments and 24-hour package lockers, enhancing the overall living experience. Enjoy all the benefits of living near King County while basking in the tranquility and comfort of Pembrooke Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near King County, WA",
      "seo_description": "Explore spacious two-bedroom living at Pembrooke Apartments near King County. Enjoy modern amenities and a great location in Kent, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-near-highline-college-kent",
      "search_query": "apartments near Highline College Kent",
      "category": "School",
      "h1_title": "Apartments Near Highline College, Kent",
      "h2_subtitle": "Discover ideal living close to Highline College at Pembrooke Apartments in Kent, WA, offering great amenities.",
      "page_copy": "If you’re looking for convenient living near Highline College in Kent, WA, Pembrooke Apartments puts you right where you need to be. Our community offers modern amenities and easy access to the college, ideal for students and educators seeking proximity and comfort.\n\nLocated just a short distance from Highline College, Pembrooke Apartments allows you to enjoy smoke-free living, a refreshing outdoor seasonal pool, and a relaxing jogging trail. With conveniences like online rent payments and 24-hour package lockers, managing daily life becomes effortless. Choose Pembrooke Apartments for a balanced lifestyle right near the academic hub of Kent.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Highline College, Kent, WA",
      "seo_description": "Find convenient apartment living at Pembrooke near Highline College Kent, offering modern amenities like package lockers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-near-multicare-auburn-medical-center-98032",
      "search_query": "apartments near MultiCare Auburn Medical Center 98032",
      "category": "Hospital",
      "h1_title": "Apartments Near MultiCare Auburn Medical Center",
      "h2_subtitle": "Live near MultiCare Auburn Medical Center by choosing Pembrooke Apartments in Kent, WA, with comfortable amenities.",
      "page_copy": "Living near MultiCare Auburn Medical Center is made easy with Pembrooke Apartments, conveniently located in Kent, WA, 98032. Our community is perfect for healthcare professionals and patients seeking nearby accommodations that blend convenience with comfort.\n\nPembrooke Apartments offers a variety of amenities, including a smoke free environment, a refreshing outdoor seasonal pool, and a jogging trail. Additional conveniences such as online rent payments and 24-hour package lockers make managing day-to-day activities effortless. Experience easy access to MultiCare Auburn Medical Center while enjoying the serenity and modern living of Pembrooke Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MultiCare Auburn Medical Center",
      "seo_description": "Choose Pembrooke Apartments in Kent, WA, for convenient living near MultiCare Auburn Medical Center with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "pembrooke-apartments-near-virginia-mason-urgent-care-federal-way",
      "search_query": "Pembrooke Apartments close to Virginia Mason Urgent Care Federal Way",
      "category": "Hospital",
      "h1_title": "Pembrooke Apartments Near Virginia Mason Urgent Care",
      "h2_subtitle": "Find your home at Pembrooke Apartments, conveniently located near Virginia Mason Urgent Care in Federal Way, WA.",
      "page_copy": "Pembrooke Apartments offers a prime location close to Virginia Mason Urgent Care, Federal Way. Ideal for healthcare professionals or anyone needing proximity to urgent care services, our community provides a seamless blend of accessibility and comfort.\n\nSituated in a peaceful setting, Pembrooke Apartments offers a plethora of amenities like a jogging trail, an outdoor seasonal pool, and smoke free housing. Additional conveniences such as online rent payments and 24-hour package lockers ensure a hassle-free living experience. Experience the perfect balance of relaxation and readiness at Pembrooke Apartments near Virginia Mason Urgent Care.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pembrooke Apartments Near Virginia Mason Urgent Care",
      "seo_description": "Experience convenient living at Pembrooke Apartments near Virginia Mason Urgent Care, Federal Way, with modern amenities and a great Kent location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-near-saltwater-state-park-king-county",
      "search_query": "apartments near saltwater state park king county",
      "category": "Park",
      "h1_title": "Apartments Near Saltwater State Park",
      "h2_subtitle": "Enjoy living close to Saltwater State Park with Pembrooke Apartments in King County, offering great amenities.",
      "page_copy": "Experience the beauty of nature by living near Saltwater State Park at Pembrooke Apartments in King County. Our prime location offers the perfect retreat for outdoor enthusiasts who enjoy the serenity and activities that the park provides.\n\nPembrooke Apartments is designed to enhance your living experience with its array of amenities, such as a scenic jogging trail, an inviting outdoor seasonal pool, and smoke free housing. Our location allows you to make online rent payments and securely receive packages with our 24-hour lockers. Discover the balance of natural beauty and modern convenience at Pembrooke Apartments, right near Saltwater State Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saltwater State Park, King County",
      "seo_description": "Live close to nature at Pembrooke Apartments near Saltwater State Park, King County, offering modern comforts and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-close-to-angle-lake-park-kent-wa",
      "search_query": "apartments close to angle lake park kent wa",
      "category": "Park",
      "h1_title": "Apartments Close to Angle Lake Park",
      "h2_subtitle": "Discover living near Angle Lake Park with Pembrooke Apartments, located conveniently in Kent, WA.",
      "page_copy": "Pembrooke Apartments offers a perfect location for those who love outdoor activities, being close to Angle Lake Park in Kent, WA. Whether you enjoy picnics, leisurely walks, or simply relaxing by the water, living near such a beautiful park enriches your lifestyle.\n\nOur community ensures modern comfort with amenities like a delightful outdoor seasonal pool, smoke free housing, and a convenient jogging trail that complements your active lifestyle. Plus, with online rent payments and 24-hour package lockers, Pembrooke Apartments caters to all your modern living needs. Experience serene living near Angle Lake Park at Pembrooke Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Angle Lake Park, Kent WA",
      "seo_description": "Explore Pembrooke Apartments close to Angle Lake Park in Kent, WA, where modern amenities meet natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "pembrooke-apartments-steel-lake-park-nearby",
      "search_query": "pembrooke apartments steel lake park nearby",
      "category": "Park",
      "h1_title": "Pembrooke Apartments Near Steel Lake Park",
      "h2_subtitle": "Enjoy the proximity of Steel Lake Park while living at Pembrooke Apartments, offering a perfect blend of nature and comfort.",
      "page_copy": "Situated conveniently near Steel Lake Park, Pembrooke Apartments provides residents with easy access to the picturesque beauty and recreational activities of this local gem. Perfect for families and individuals who cherish outdoor adventures, our community offers everything you need for a comfortable yet active lifestyle.\n\nWith amenities like a scenic jogging trail, a refreshing outdoor seasonal pool, and the convenience of smoke free housing, Pembrooke Apartments ensures a wholesome living experience. Residents can also take advantage of online rent payments and 24-hour package lockers for an effortless daily routine. Embrace the best of both worlds with Pembrooke Apartments near Steel Lake Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pembrooke Apartments Near Steel Lake Park",
      "seo_description": "Discover comfort and nature at Pembrooke Apartments, located near Steel Lake Park with excellent amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "valley-ridge-community-center-ball-fields-near-pembrooke",
      "search_query": "valley ridge community center ball fields near pembrooke apartments",
      "category": "Park",
      "h1_title": "Ball Fields at Valley Ridge Near Pembrooke",
      "h2_subtitle": "Live near Valley Ridge Community Center's ball fields at Pembrooke Apartments, where fun meets convenience.",
      "page_copy": "Pembrooke Apartments places you within easy reach of Valley Ridge Community Center's ball fields, making it a perfect home for sports enthusiasts and families. With these recreational facilities so close by, residents can readily engage in community activities or enjoy casual ball games.\n\nOur community not only offers proximity to these fantastic amenities but also provides modern conveniences such as a jogging trail, an outdoor seasonal pool, and smoke free housing. Stay connected with online rent payments and enjoy the ease of 24-hour package lockers. Experience a vibrant community life at Pembrooke Apartments, just a stone's throw from Valley Ridge Community Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Valley Ridge Ball Fields Near Pembrooke Apartments",
      "seo_description": "Enjoy living near Valley Ridge Community Center ball fields at Pembrooke Apartments, offering modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-tacoma-airport-kent-wa",
      "search_query": "apartments near seattle–tacoma international airport kent wa",
      "category": "Transit",
      "h1_title": "Apartments Near Seattle-Tacoma Airport",
      "h2_subtitle": "Find your home near Seattle–Tacoma International Airport at Pembrooke Apartments, a prime location in Kent, WA.",
      "page_copy": "If proximity to Seattle-Tacoma International Airport is a priority, look no further than Pembrooke Apartments in Kent, WA. Our location is ideal for frequent travelers and professionals, offering easy access to one of the major transit hubs in the region.\n\nIn addition to convenience, Pembrooke Apartments boasts amenities such as a jogging trail, a delightful outdoor seasonal pool, and a commitment to smoke free living. Residents benefit from modern conveniences like online rent payments and 24-hour package lockers, ensuring a hassle-free lifestyle. Choose comfort and accessibility at Pembrooke Apartments, just a short drive from Sea-Tac Airport.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle-Tacoma Airport, Kent WA",
      "seo_description": "Discover Pembrooke Apartments in Kent, WA, near Seattle-Tacoma International Airport, with top amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166899",
      "source": "generator",
      "page_item_url": "apartments-close-to-angle-lake-king-county",
      "search_query": "apartments close to angle lake king county",
      "category": "Transit",
      "h1_title": "Apartments Close to Angle Lake",
      "h2_subtitle": "Explore living near Angle Lake in King County at Pembrooke Apartments, offering modern amenities and a serene environment.",
      "page_copy": "Pembrooke Apartments offers an ideal location for those looking to live close to the tranquil shores of Angle Lake in King County. Experience the balance of serene lake life and modern conveniences, making every day feel like a retreat.\n\nOur community features include a jogging trail, an outdoor seasonal pool, and smoke-free living, all designed to enhance your lifestyle. Enjoy the practicality of online rent payments and the security of 24-hour package lockers. Embrace a harmonious balance of nature and convenience at Pembrooke Apartments, situated just a short distance from Angle Lake.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Angle Lake in King County",
      "seo_description": "Live near Angle Lake in King County at Pembrooke Apartments with excellent amenities and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5946"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372412560"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WPJ3DTMV"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-494-6385 "
    }
  ],
  "custom_qb_id": "5946",
  "custom_repli_id": "18372412560",
  "custom_google_gtm_id": "GTM-WPJ3DTMV",
  "custom_ppc_tracking_phone_number": "844-494-6385 "
};

export const generatedAt = '2026-09-23T19:55:40.137Z';
